import { Injectable, NgZone, OnDestroy } from '@angular/core';
import { Observable, Subject, of, throwError, BehaviorSubject } from 'rxjs';
import { Globals } from 'src/app/globals';
import Dexie from 'dexie';
import { CookieService } from 'ngx-cookie-service';
import { Router, ActivatedRoute } from "@angular/router"
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpResponse, HttpEvent } from '@angular/common/http';
//import { CurrencyPipe } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { User, UserAccess } from 'src/app/services/userStore/user.model';
import { AppLoadService } from '../app-load.service';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';

import * as Driver from 'driver.js';
import { MessageDialogComponent } from 'src/app/components/message-dialog/message-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { switchMap, debounceTime, tap, finalize, map, startWith, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { MsalService, BroadcastService } from '@azure/msal-angular';
import { MenuItem, MessageService } from 'primeng/api';
import { AlertMessageCustomComponent } from '../../components/alert-message-custom/alert-message-custom.component';
import { FormControl } from '@angular/forms';
import { MatSelectConfig } from '@angular/material/select';
import { v4 as uuid } from 'uuid';
import { FileServiceService } from 'src/app/services/file-service.service'

import * as FileSaver from 'file-saver';
import * as cheerio from 'cheerio';

import { PgeTokenService } from 'src/app/services/pgeToken/pge-token.service';

import * as moment from 'moment-timezone';
import { AppEventMessagesService } from '../application-state.service';
import confetti from 'canvas-confetti';

export interface appModuleDataObject {
  module?: string,
  isActive?: boolean,
  isActiveAdmin?: boolean;
}

export interface appModuleObject {
  id?: number;
  createdDate?: Date,
  createdBy?: string,
  createdByName?: string;
  name?: string,
  description?: string,
  permissionRequired?: boolean,
  moduleData?: appModuleDataObject[],
  moduleDataString?: string,
  canEdit?: boolean;
  canDelete?: boolean;
  status?: string;
  isActive?: boolean;
  statusAdmin?: string;
  isActiveAdmin?: boolean;
}

export interface documentAnswerSchema {
  column: any;
  columnObject: any;
  name?: any;
  answer?: any;
  answerObject?: any;
  comments?: any[];
  documents?: any;
  tableData?: any[];
  tableDataSchema?: any[];
  questionType?: string;
  questionTypeKey?: string;
  metaData?: any;
  children?: documentAnswerSchema[];
}

export interface databaseObject {
  position: number;
  value: string;
  label: string;
  lastSynced: Date;
  synced: boolean;
  canRefresh: boolean;
}

export interface errorObject {
  id?: number;
  module?: string;
  employeeName?: string;
  employeeEmail?: string;
  errorDate?: Date;
  errorDetails?: string;
  sendEmail?: boolean;
}

export interface outageObject {
  showItem: boolean,
  message: string;
}

export interface customAlertMessage {
  severity?: string;
  message?: string;
  action?: string;
  horizontalPosition?: MatSnackBarHorizontalPosition;
  verticalPosition?: MatSnackBarVerticalPosition;
  panelClass?: string;
  summary?: string;
  detail?: string;
  id?: any;
  key?: string;
  life?: number;
  duration?: number;
  sticky?: boolean;
  closable?: boolean;
  data?: any;
  icon?: string;
  snackType?: string;
}

export interface itemConditionClause {
  id?: number;
  key?: string;
  value?: string;
  valueType?: string;
  dataType?: string;
  operator?: string;
  and_or?: string;
  active?: boolean;
  isEmployeeOrg?: boolean;
  conditionKeyControl?: FormControl;
  conditionValueControl?: FormControl;
  operatorControl?: FormControl;
  andOrControl?: FormControl;
  keyOptionArray?: itemKeyObject[];
  operatorArray?: any[];

}

export interface itemKeyObject {
  name?: string;
  value?: string;
  label?: string;
  description?: string;
  dataType?: string;
  ruleTable?: string;
  ticked?: boolean;
}

export interface statusOptions {
  status?: string;
}


export interface itemConditionGroup {
  id?: number;
  value?: string;
  and_or?: string;
  active?: boolean;
  andOrControl?: FormControl;
  groupConditions?: itemConditionClause[];
}

export interface userEmailDistroObject {
  position: number;
  ID: number;
  employeeName: string;
  employeeEmail: string;
  module: string;
  reportName: string;
  brand: string;
  canDelete: boolean;
  canEdit: boolean;
  reportKey?: string;
  moduleDistroData?: itemConditionGroup[];
  emailDistroString?: string;
  status?: string;
}

export interface reportAccessObject {
  position: number;
  ID: number;
  createdDate: Date;
  createdByName: string;
  createdByEmail: string;
  brand: string;
  groupName: string;
  reportName: string;
  reportType: string;
  reportDescription: string;
  hasAccess: boolean;
  groupAdmins: any;
  roleData?: string[];
  roleDataString?: any;
}



/*ACCESS CONDITIONS*/
/*
export interface userAccessConditionsObject {
  position: number;
  ID: number;
  employeeName: string;
  employeeEmail: string;
  module: string;
  reportName: string;
  brand: string;
  canDelete: boolean;
  canEdit: boolean;
  reportKey?: string;
  moduleDistroData?: itemConditionGroup[];
  conditionString?: string;
}
*/

export interface accessItemConditionClause {
  id?: number;
  key?: string;
  value?: string;
  valueType?: string;
  dataType?: string;
  operator?: string;
  and_or?: string;
  active?: boolean;
  isEmployeeOrg?: boolean;
  conditionKeyControl?: FormControl;
  conditionValueControl?: FormControl;
  operatorControl?: FormControl;
  andOrControl?: FormControl;
  keyOptionArray?: accessItemKeyObject[];
  operatorArray?: any[];
}

export interface accessItemKeyObject {
  name?: string;
  value?: string;
  label?: string;
  description?: string;
  dataType?: string;
  ruleTable?: string;
  ticked?: boolean;
}


export interface subModuleAccessObject {
  module?: string;
  conditions?: itemConditionGroup[];
  conditionString?: string;
  //accessItemConditionClause[]
}

export interface userAccessObject {
  position?: number;
  ID: number;
  createdDate?: Date;
  createdByName?: string;
  createdByEmail?: string;
  employeeName?: string;
  username?: string;
  employeeEmail?: string;
  employeeEmail_Alternate?: string;
  module?: string;
  moduleData?: any;
  accessLevel?: string;
  brand?: string;
  canDelete?: boolean;
  canEdit?: boolean;
  access?: subModuleAccessObject[];
  employeeStatus?: string;
  moduleDataDefault?: subModuleAccessObject[];
  includeModuleData?: boolean;
}

export interface userAccessObject_Reports {
  position?: number;
  ID?: number;
  createdDate?: Date;
  createdByName?: string;
  createdByEmail?: string;
  employeeName?: string;
  employeeNumber?: string;
  username?: string;
  employeeEmail?: string;
  employeeEmail_Alternate?: string;
  module?: string;
  moduleData?: any;
  moduleDataString?: any;
  accessLevel?: string;
  brand?: string;
  canDelete?: boolean;
  canEdit?: boolean;
  employeeStatus?: string;
}

export interface toolBoxObject {
  name?: string;
  description?: string;
  type?: string;
  url?: string;
  urlParamsId?: string;
  urlParams?: string;
  urlParams_Approve?: string;
  urlParams_Reject?: string;
  useRouter?: boolean;
  toolTip?: string;
  clickAction?: string;
  ID?: any;
  children?: toolBoxObject[];
  confirmAction?: boolean;
  includeApproveReject?: boolean;
}

export interface myApprovalObject {
  name?: string;
  description?: string;
  type?: string;
  url?: string;
  urlParamsId?: string;
  urlParams?: string;
  useRouter?: boolean;
  toolTip?: string;
  clickAction?: string;
  ID?: any;
  children?: toolBoxObject[];
}


@Injectable({
  providedIn: 'root',
})
export class IdbPowerPortalService implements OnDestroy {
  private db: any;
  userObject: User;
  listOfOrgs = [];
  tourdriver: Driver;
  ngUnsubscribe = new Subject<void>();
  private appVersionMessage = new Subject<any>();
  weekDayNamesArray = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  public dbVersion: number;


  appVersionMessageJSON = {
    showItem: false,
    activeVersion: "",
    currentVersion: "",
    currentVersionIsLatest: true,
    updateRequired: false,
    message: "A new version is available and includes critical updates.  The updated vesion is being downloaded now.  Just a moment",
  }

  constructor(
    public globals: Globals,
    private http: HttpClient,
    private cookies: CookieService,
    private router: Router,
    private appLoadService: AppLoadService,
    private _snackBar: MatSnackBar,
    private zone: NgZone,
    private dialog: MatDialog,
    private authService: MsalService,
    private messageService: MessageService,
    private titleService: Title,
    private appEventMessagesService: AppEventMessagesService,
    //private pgeToken: PgeTokenService,
    private fileService: FileServiceService,
    //private currencyPipe: CurrencyPipe,
  ) {
    this.dbVersion = globals.dbVersion_POWER_PORTAL_DB;
    this.registerServiceWorkerMessages();
  }

  registerServiceWorkerMessages() {
    this.appEventMessagesService.get_event_messages_data.pipe(takeUntil(this.ngUnsubscribe)).subscribe((event) => {
      //NETWORK RECONNECT, TRIGGER SYNC...
      if (event.data?.type === 'NETWORK_ONLINE') {
        this.onNetworkRestored();
      }

      //UPDATE BADGE ICONS
      if (event.data?.type === 'UPDATE_BADGE_ICON') {
        console.log("update badge icon..")
        var notificationArray = [...this.notificationsData];
        var notification = event.data?.data;
        notificationArray.push(notification);
        this.updateNotifications(notificationArray);
      }

      //NAVIGATE TO ROUTE URL
      if (event.data?.type === 'NAVIGATE_URL') {
        console.log("start route to url...")
        if (event.data?.url) {
          console.log("url: " + event.data?.url)
          /*
          var savedHREF = {
            module: "Notification Alert",
            link: event.data?.url
          }
          this.updateItem({ itemName: "saved_redirect_url", value: savedHREF }, (results) => { });
          */
          /*
           setTimeout(() => {
             location.href = event.data?.url
           }, 0);
           */

          if (event.data?.urlPath) {
            this.router.navigate(['/' + event.data?.urlPath]).then(nav => {
            }, err => {
              console.log("Route Error: " + err + ". routeValue: " + event.data?.urlPath);
            })
          }
        }
      }
    })
  }


  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  upgradeNeeded = (request) => {

    //1) INFO
    var storeAddOne = "info";
    var db = request.result;
    if (db.objectStoreNames.contains(storeAddOne)) {
      db.deleteObjectStore(storeAddOne);
    }
    var store = db.createObjectStore(storeAddOne, {
      keyPath: "itemName"
    });


    //2) ERROR LOG
    var storeAddTwo = "errorLog";
    var dbTwo = request.result;
    if (dbTwo.objectStoreNames.contains(storeAddTwo)) {
      dbTwo.deleteObjectStore(storeAddTwo);
    }
    var storetwo = db.createObjectStore(storeAddTwo, {
      keyPath: "id"
    });

  }


  get appVersionEventChanged() {
    return this.appVersionMessage.asObservable();
  }

  public appVersionUpdateCheck(appData) {

    this.appVersionMessageJSON.activeVersion = appData.activeVersion;
    this.appVersionMessageJSON.currentVersion = appData.currentVersion;
    this.appVersionMessageJSON.updateRequired = appData.updateRequired;

    if (appData.message !== "") {
      this.appVersionMessageJSON.message = appData.message;
    }

    var currentVersion = 0;
    if (appData.currentVersion !== "") {
      currentVersion = Number(appData.currentVersion.replaceAll('.', ''));
    }

    var activeVersion = 0;
    if (appData.activeVersion !== "") {
      activeVersion = Number(appData.activeVersion.replaceAll('.', ''));
    }

    if (this.appVersionMessageJSON.activeVersion === this.appVersionMessageJSON.currentVersion) {
      this.appVersionMessageJSON.currentVersionIsLatest = true;
      this.appVersionMessageJSON.showItem = false;
    } else {
      if (currentVersion < activeVersion) {
        this.appVersionMessageJSON.currentVersionIsLatest = false;
      } else {
        this.appVersionMessageJSON.currentVersionIsLatest = true;
        this.appVersionMessageJSON.showItem = false;
      }
    }

    if (!this.appVersionMessageJSON.currentVersionIsLatest) {
      this.appVersionMessageJSON.showItem = appData.updateRequired;
    } else {
      this.appVersionMessageJSON.showItem = false;
    }

    var dataObj = { itemName: "appVersionUpdateRequired", value: this.appVersionMessageJSON };
    this.updateItem(dataObj, (results) => { });
    this.appVersionMessage.next(this.appVersionMessageJSON);
  }






  updateItem = (data, callBack) => {
    var searchString = data.itemName;
    var objectStoreName = "info";
    var storeNames = [objectStoreName];

    var resultObj = {
      message: ""
    }

    if (indexedDB) {
      var request = indexedDB.open('POWER_PORTAL_DB', this.dbVersion);
      var db;

      var updateData = () => {

        var objectStore = db.transaction(objectStoreName, 'readwrite').objectStore(objectStoreName);

        var db_op_req = objectStore.put(data);
        db_op_req.onsuccess = (event) => {
          resultObj.message = "success";
          callBack(resultObj);
        };
        db_op_req.onerror = (event) => {
          resultObj.message = "error";
          callBack(resultObj);
        };
      };

      request.onupgradeneeded = (event) => {
        this.upgradeNeeded(request);
      };

      request.onsuccess = (event) => {
        db = request.result;
        updateData();
      };

      request.onerror = (event) => {
        resultObj.message = "error";
        callBack(resultObj);
      };

    } else {
      resultObj.message = "notSupported";
      callBack(resultObj);
    }
  };

  getItem = (itemName, callBack) => {
    var objectStoreName = "info";
    var storeNames = [objectStoreName];

    var resultObj = {
      itemFound: false,
      value: ""
    }

    if (indexedDB) {
      var request = indexedDB.open('POWER_PORTAL_DB', this.dbVersion);
      var db;

      var getData = () => {
        var transaction = db.transaction(objectStoreName, 'readwrite')
        var objectStore = transaction.objectStore(objectStoreName);
        var dataResults = [];

        transaction.oncomplete = (event) => {
          callBack(resultObj); //I THINK WE ONLY NEED THIS
        };

        objectStore.openCursor().onsuccess = (event) => {
          var itemFound = false;
          var cursor = event.target.result;
          if (cursor) {
            if (cursor.value.itemName.indexOf(itemName) !== -1) {
              itemFound = true;
              resultObj.itemFound = true;
              resultObj.value = cursor.value.value;
              if (itemName !== "SS_GoodBye_Index_Array") {  //TESTING ON 'SS_GoodBye_Index_Array'
                //callBack(resultObj); //I THINK WE CAN REMOVE THIS, IT ALREADY RETURNS ONCE THE TRANSACITON IS COMPLETE 'oncomplete'
              }
            } else {
              cursor.continue();
            }
          }

          if (!itemFound) {
            //callBack(resultObj);
          }

        };
      };

      request.onupgradeneeded = (event) => {
        this.upgradeNeeded(request);
      };

      request.onsuccess = (event) => {
        db = request.result;
        getData();
      };

      request.onerror = (event) => {
        callBack(resultObj);
      };

    } else {
      callBack(resultObj);
    }
  };

  searchDataBase = (searchString, callBack) => {

    var objectStoreName = "info";
    var storeNames = [objectStoreName];

    var allProjectData = [];


    if (indexedDB) {
      var request = indexedDB.open('POWER_PORTAL_DB', this.dbVersion);
      var db;

      var getData = () => {
        var transaction = db.transaction(objectStoreName, 'readwrite');
        var dataResults = [];

        transaction.oncomplete = (event) => {
          if (dataResults.length > 0) {
            callBack(dataResults);
          }
        };

        var objectStore = transaction.objectStore(objectStoreName);

        objectStore.openCursor().onsuccess = (event) => {
          var cursor = event.target.result;
          if (cursor) {
            if (cursor.value.projectName.indexOf(searchString) !== -1) {
              dataResults.push(cursor.value);
            }
            cursor.continue();
          }
          if (dataResults.length > 0) {
            callBack(dataResults);
          }
        };
      };

      request.onupgradeneeded = (event) => {
        this.upgradeNeeded(request);
      };

      request.onsuccess = (event) => {
        db = request.result;
        getData();
      };

      request.onerror = (event) => {
        callBack(allProjectData);
      };

    } else {
      callBack(allProjectData);
    }
  };

  getDataObjects = (callBack) => {

    var objectStoreName = "info";
    var storeNames = [objectStoreName];

    var allResultData = [];
    var db;

    if (indexedDB) {
      var request = indexedDB.open('POWER_PORTAL_DB', this.dbVersion);

      var getData = () => {
        var transaction = db.transaction(objectStoreName, 'readwrite');
        var objectStore = transaction.objectStore(objectStoreName);

        if ('getAll' in objectStore) {
          objectStore.getAll().onsuccess = (event) => {
            var dataResults = event.target.result;
            callBack(dataResults);
          };
        } else {
          // Fallback to the traditional cursor approach if getAll isn't supported.
          var dataResults = [];
          objectStore.openCursor().onsuccess = (event) => {
            var cursor = event.target.result;
            if (cursor) {
              dataResults.push(cursor.value);
              cursor.continue();
            }
          };
          callBack(dataResults);
        }
      };


      request.onupgradeneeded = (event) => {
        this.upgradeNeeded(request);
      };

      request.onsuccess = (event) => {
        db = request.result;
        getData();
      };


      request.onerror = (event) => {
        callBack(allResultData);
      };

    } else {
      callBack(allResultData);
    }
  };

  getDataObjectsCount = (callBack) => {

    var objectStoreName = "info";
    var storeNames = [objectStoreName];

    var data = {
      message: "",
      recordCount: 0
    }

    var allRecordCount = 0;
    var db;

    if (indexedDB) {
      var request = indexedDB.open('POWER_PORTAL_DB', this.dbVersion);

      var getCount = () => {
        var transaction = db.transaction(objectStoreName, 'readwrite');
        var objectStore = transaction.objectStore(objectStoreName);
        var recordCount = 0;
        objectStore.count().onsuccess = (event) => {
          recordCount = event.target.result;
          data.recordCount = recordCount;
          data.message = "success";
          callBack(data);
        };
      };

      request.onupgradeneeded = (event) => {
        this.upgradeNeeded(request);
      };

      request.onsuccess = (event) => {
        db = request.result;
        getCount();
      };

      request.onerror = (event) => {
        data.message = "error";
        callBack(data);
      };

    } else {
      data.message = "notSupported";
      callBack(data);
    }
  };

  insertNewObject = (data, callBack) => {

    var objectStoreName = "info";
    var storeNames = [objectStoreName];
    var db;

    if (indexedDB) {

      var request = indexedDB.open('POWER_PORTAL_DB', this.dbVersion);

      request.onupgradeneeded = (event) => {
        this.upgradeNeeded(request);
      };

      var insertDataIntoTable = (insertData, insertCallBack) => {

        var transaction = db.transaction(objectStoreName, 'readwrite');
        var objectsStore = transaction.objectStore(objectStoreName);
        var db_op_req = objectsStore.add(insertData);

        db_op_req.onsuccess = (event) => {

        };
        db_op_req.onerror = (event) => {

        };
        insertCallBack("Success");
      };

      request.onsuccess = (event) => {
        db = request.result; // === request.result
        insertDataIntoTable(data, (result) => {
        });
      };

      request.onerror = (event) => {
        callBack("Error");
      };

    } else {
      callBack("Error");
    }

  };


  updateDataTable = (responseData) => {

    var objectStoreName = "info";
    var storeNames = [objectStoreName];

    if (indexedDB) {

      var request = indexedDB.open('POWER_PORTAL_DB', this.dbVersion);

      request.onupgradeneeded = (event) => {
        this.upgradeNeeded(request);
      };


      request.onsuccess = (event) => {

        var db = request.result;
        var transaction = db.transaction(storeNames, 'readwrite');
        request.onsuccess = (event) => {

        };

        var objectsStore = transaction.objectStore('info');

        responseData.forEach((itemObject) => {
          var db_op_req = objectsStore.add(itemObject);

          db_op_req.onsuccess = (event) => {

          };
          db_op_req.onerror = (event) => {

          };
        });

        objectsStore.count().onsuccess = (event) => {

        };
        return "success";
      };

      request.onerror = (event) => {
        return "error: " + request.error;
      };


    } else {
      return "indexedDB is not supported";
    }
  };

  deleteObject = (objectId, callBack) => {

    var objectStoreName = "info";
    var storeNames = [objectStoreName];
    var db;

    if (indexedDB) {

      var request = indexedDB.open('POWER_PORTAL_DB', this.dbVersion);

      request.onupgradeneeded = (event) => {
        this.upgradeNeeded(request);
      };

      var deleteData = (objectId) => {
        var transaction = db.transaction(objectStoreName, 'readwrite');
        var objectsStore = transaction.objectStore(objectStoreName);
        var objectStoreRequest = objectsStore.delete(objectId);

        objectStoreRequest.onsuccess = (event) => {
          callBack("Success");
        };
      };

      request.onsuccess = (event) => {
        db = request.result;
        deleteData(objectId);
      };

      request.onerror = (event) => {
        callBack("Error");
      };

    } else {
      callBack("Error");
    }

  };





  //ERROR LOG
  getDataObjects_Error = (callBack) => {

    var objectStoreName = "errorLog";
    var storeNames = [objectStoreName];

    var allResultData = [];
    var db;

    if (indexedDB) {
      var request = indexedDB.open('POWER_PORTAL_DB', this.dbVersion);

      var getData = () => {
        var transaction = db.transaction(objectStoreName, 'readwrite');
        var objectStore = transaction.objectStore(objectStoreName);

        if ('getAll' in objectStore) {
          objectStore.getAll().onsuccess = (event) => {
            var dataResults = event.target.result;
            callBack(dataResults);
          };
        } else {
          // Fallback to the traditional cursor approach if getAll isn't supported.
          var dataResults = [];
          objectStore.openCursor().onsuccess = (event) => {
            var cursor = event.target.result;
            if (cursor) {
              dataResults.push(cursor.value);
              cursor.continue();
            }
          };
          callBack(dataResults);
        }
      };


      request.onupgradeneeded = (event) => {
        this.upgradeNeeded(request);
      };

      request.onsuccess = (event) => {
        db = request.result;
        getData();
      };


      request.onerror = (event) => {
        callBack(allResultData);
      };

    } else {
      callBack(allResultData);
    }
  };

  getDataObjectsCount_Error = (callBack) => {

    var objectStoreName = "errorLog";
    var storeNames = [objectStoreName];

    var data = {
      message: "",
      recordCount: 0
    }

    var allRecordCount = 0;
    var db;

    if (indexedDB) {
      var request = indexedDB.open('POWER_PORTAL_DB', this.dbVersion);

      var getCount = () => {
        var transaction = db.transaction(objectStoreName, 'readwrite');
        var objectStore = transaction.objectStore(objectStoreName);
        var recordCount = 0;
        objectStore.count().onsuccess = (event) => {
          recordCount = event.target.result;
          data.recordCount = recordCount;
          data.message = "success";
          callBack(data);
        };
      };

      request.onupgradeneeded = (event) => {
        this.upgradeNeeded(request);
      };

      request.onsuccess = (event) => {
        db = request.result;
        getCount();
      };

      request.onerror = (event) => {
        data.message = "error";
        callBack(data);
      };

    } else {
      data.message = "notSupported";
      callBack(data);
    }
  };

  insertNewObject_Error = (data: errorObject, callBack) => {

    var employeeName = this.userObject.name;
    var employeeEmail = this.userObject.email;

    var module = ""; if (data.module) { module = data.module; }
    var errorDetails = ""; if (data.errorDetails) { errorDetails = data.errorDetails; }
    var errorDate: Date = new Date();
    var uid = uuid();

    var errorObjectData: errorObject = {
      id: uid,
      employeeEmail: employeeEmail,
      employeeName: employeeName,
      module: module,
      errorDetails: btoa(errorDetails),
      errorDate: errorDate,
    }

    var objectStoreName = "errorLog";
    var storeNames = [objectStoreName];
    var db;

    if (indexedDB) {

      var request = indexedDB.open('POWER_PORTAL_DB', this.dbVersion);

      request.onupgradeneeded = (event) => {
        this.upgradeNeeded(request);
      };

      var insertDataIntoTable = (insertData, insertCallBack) => {

        var transaction = db.transaction(objectStoreName, 'readwrite');
        var objectsStore = transaction.objectStore(objectStoreName);
        var db_op_req = objectsStore.add(insertData);

        db_op_req.onsuccess = (event) => {

        };
        db_op_req.onerror = (event) => {

        };
        insertCallBack("Success");
      };

      var updateData = (insertData, insertCallBack) => {
        var objectStore = db.transaction(objectStoreName, 'readwrite').objectStore(objectStoreName);
        var db_op_req = objectStore.put(insertData);
        db_op_req.onsuccess = (event) => {
          insertCallBack("Success");
        };
        db_op_req.onerror = (event) => {
          insertCallBack("Error");
        };
      };


      request.onsuccess = (event) => {
        db = request.result;
        /*
        insertDataIntoTable(errorObjectData, (result) => {
        });
        */
        updateData(errorObjectData, (result) => {
        });
      };

      request.onerror = (event) => {
        callBack("Error");
      };

    } else {
      callBack("Error");
    }

  };

  deleteObject_Error = (objectId, callBack) => {

    var objectStoreName = "errorLog";
    var storeNames = [objectStoreName];
    var db;

    if (indexedDB) {

      var request = indexedDB.open('POWER_PORTAL_DB', this.dbVersion);

      request.onupgradeneeded = (event) => {
        this.upgradeNeeded(request);
      };

      var deleteData = (objectId) => {
        var transaction = db.transaction(objectStoreName, 'readwrite');
        var objectsStore = transaction.objectStore(objectStoreName);
        var objectStoreRequest = objectsStore.delete(objectId);

        objectStoreRequest.onsuccess = (event) => {
          callBack("Success");
        };
      };

      request.onsuccess = (event) => {
        db = request.result;
        deleteData(objectId);
      };

      request.onerror = (event) => {
        callBack("Error");
      };

    } else {
      callBack("Error");
    }

  };


  get_indexDB_status(): Observable<any[]> {

    return Observable.create(observer => {

      var draftCount = 0;
      var loadedReportId_Draft = 0;

      var returnObj: databaseObject = {
        position: 1,
        value: "employees",
        label: "Employees",
        lastSynced: new Date(),
        synced: true,
        canRefresh: true
      }

      observer.next(returnObj);
      observer.complete();

    })
  }


  get_IndexedDB_List = (callBack) => {

    var itemName = "indexedDB_";

    var objectStoreName = "info";
    var storeNames = [objectStoreName];

    var resultObj = {
      itemFound: false,
      value: []
    }


    if (indexedDB) {
      var request = indexedDB.open('POWER_PORTAL_DB', this.dbVersion);
      var db;

      var getData = () => {

        var transaction = db.transaction(objectStoreName, 'readwrite');
        var objectStore = transaction.objectStore(objectStoreName);
        var dataResults = [];

        transaction.oncomplete = (event) => {
          if (dataResults.length > 0) {
            resultObj.itemFound = true;
          }

          resultObj.value = dataResults
          callBack(resultObj);
        };

        objectStore.openCursor().onsuccess = (event) => {
          var itemFound = false;
          var cursor = event.target.result;
          if (cursor) {
            if (cursor.value.itemName.indexOf(itemName) !== -1) {
              dataResults.push(cursor.value);
            }
            cursor.continue();
          }
        };
      };

      request.onupgradeneeded = (event) => {
        this.upgradeNeeded(request);
      };

      request.onsuccess = (event) => {
        db = request.result;
        getData();
      };

      request.onerror = (event) => {
        callBack(resultObj);
      };

    } else {
      callBack(resultObj);
    }
  };


  /*
  //REGISTER EVENT IF OFFLINE MODE IS USED
  registerNetworkSync(): void {
    navigator.serviceWorker.ready.then(reg => {
      const swReg: any = reg;
      if ('sync' in swReg) {
        swReg.sync.register('notify-app-online')
          .then(() => console.log('Background sync registered'))
          .catch(err => console.error('Failed to register sync', err));
      } else {
        console.warn('Background Sync not supported — using fallback');
        //this.handleNetworkRestoredManually();
      }
    });
  }


  //LISTEN FOR NETWORK SYNC MESSAGE
  listenForServiceMessages(fromModule: string = 'na') {
    if (this.userObject && this.userObject.email.toLowerCase() === "jared.stevens@qualuscorp.com") {
      alert("Trying to listen to messages...")
    }
    console.log("Trying to listen to messages, from module: " + fromModule)
    if (navigator.serviceWorker) {
      console.log("Trying to listen to messages, found service worker...")
      navigator.serviceWorker.addEventListener('message', event => {

        //NETWORK RECONNECT, TRIGGER SYNC...
        if (event.data?.type === 'NETWORK_ONLINE') {
          this.onNetworkRestored();
        }

        //UPDATE BADGE ICONS
        if (event.data?.type === 'UPDATE_BADGE_ICON') {
          console.log("update badge icon..")
          var notificationArray = [...this.notificationsData];
          var notification = event.data?.data;
          notificationArray.push(notification);
          this.updateNotifications(notificationArray);
        }

        //NAVIGATE TO ROUTE URL
        if (event.data?.type === 'NAVIGATE_URL') {
          console.log("start route to url...")
          if (event.data?.url) {
            console.log("url: " + event.data?.url)

            if (event.data?.urlPath) {
              this.router.navigate(['/' + event.data?.urlPath]).then(nav => {
              }, err => {
                console.log("Route Error: " + err + ". routeValue: " + event.data?.urlPath);
              })
            }
          }
        }

      });
    } else {
      console.log("unable to listen to messages, service worker not found")
    }
  }
  */

  notificationsData = [];
  public notifications_data = new Subject<any>();
  get get_notifications_data() {
    return this.notifications_data.asObservable();
  }
  public update_notifications_data(notificationsData) {
    this.notificationsData = notificationsData
    this.notifications_data.next(notificationsData)
  }

  //UPDATE NOTIFICATIONS ARRAY / BADGE ICON
  updateNotifications(notifications) {
    console.log("Update notifications: " + JSON.stringify(notifications));
    this.update_notifications_data(notifications)
    if ('setAppBadge' in navigator) {
      // @ts-ignore
      navigator.setAppBadge(notifications.length || 0);
    }
  }

  onNetworkRestored() {
    console.log('Network restored! Running background sync logic...');
    if (this.userObject.email.toLowerCase() === "jared.stevens@qualuscorp.com") {
      //alert("Network Restored!")
    }
    // Call your function here — for example:
    this.syncOfflineData();
  }

  syncOfflineData() {
    // Your custom function to process IndexedDB or update UI
    console.log('Syncing offline data...');
  }


  //TIME & EXPENSE INTEGRATION VARIABLES
  timeExpense_integrationEnvironment = false;

  private is_integration_changed = new Subject<any>();
  get getData_IsIntegrationVariable() {
    return this.is_integration_changed.asObservable();
  }
  updateData_IsIntegrationVariable(data) {
    this.timeExpense_integrationEnvironment = data;
    this.is_integration_changed.next(data);
  }


  checkTimeExpenseIntegrationTesting() {
    var isIntegration = false;
    var employeeNumber = 0; if (this.userObject.employeeNumber) { employeeNumber = this.userObject.employeeNumber; }
    var postData = [{
      dataRequest: "loadTimeSheet_Variables",
      employeeName: this.userObject.name,
      startDate: "",
      endDate: "",
      requestedByEmployeeEmail: this.userObject.email,
      employeeNumber: employeeNumber,
      loadTypeRequest: "check_CEP_Integration_Time_Expense",
    }];

    this.timeExpensePostRequest(postData).pipe(takeUntil(this.ngUnsubscribe)).subscribe((response) => {
      if (response[0].isTesting === true) {
        isIntegration = true;
      } else {
        isIntegration = false;
      }
    }, (error) => {
      //this.webWorker_PowerPortal.logError(this.online, "Time & Expense", error);
    }, () => {

      var dataObj = { itemName: "Time_Expense_Integration_Testing", value: isIntegration };
      this.updateItem(dataObj, (results) => { });

      this.updateData_IsIntegrationVariable(isIntegration);
    })
  }





  /*
  async setBadge(count: number) {
    if ('setAppBadge' in navigator) {
      try {
        await (navigator as any).setAppBadge(count);
      } catch (err) {
        console.error('Failed to set badge:', err);
      }
    } else {
      console.warn('App Badge API not supported');
    }
  }

  async clearBadge() {
    if ('clearAppBadge' in navigator) {
      await (navigator as any).clearAppBadge();
    }
  }
  */


  private org_list_changed = new Subject<any>();
  get orgList_DataChanged() {
    return this.org_list_changed.asObservable();
  }
  updateData_Org_Name_List(data) {
    this.listOfOrgs = data;
    this.org_list_changed.next(data);
  }

  //NETWORK PING STATUS CHANGE

  //network_ping: number = 0;
  private network_ping_changed = new Subject<any>();
  //private network_ping_changed = new BehaviorSubject<number>(0);
  //readonly getData_Network_Ping = this.network_ping_changed.asObservable();
  get getData_Network_Ping() {
    return this.network_ping_changed.asObservable();
  }
  updateData_Network_Ping(data) {
    //this.network_ping = data;
    this.network_ping_changed.next(data);
  }
  /*
  network_ping = 0;
  private network_ping_changed = new BehaviorSubject<number>(0);

  get getData_Network_Ping() {
    return this.network_ping_changed.asObservable();
  }

  updateData_Network_Ping(data: number) {
    this.network_ping = data;
    this.network_ping_changed.next(data);
  }
  */


  private report_access_list_changed = new Subject<any>();
  get get_report_access_list_DataChanged() {
    return this.report_access_list_changed.asObservable();
  }
  updateData_ReportAccessList(data) {
    this.report_access_list_changed.next(data);
  }


  getOrgList() {
    var postData = [{
      dataRequest: "getOrgList"
    }];

    var apiURL = this.globals.apiURL_Internal_API + '/api/PowerPortal';
    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    );

    return this.http.post(apiURL, postData, {
      headers: httpHeaders
    })
  }




  private indexedDB_Data_changed = new Subject<any>();
  get getLastSyncedData() {
    return this.indexedDB_Data_changed.asObservable();
  }
  updateLastSyncedData(data) {
    this.indexedDB_Data_changed.next(data);
  }


  redirectToSignIn() {
    this.router.navigate(['/'])
  }

  logout() {

    this.cookies.deleteAll();

    var userObject: User = {
      name: undefined,
      username: undefined,
      email: undefined,
      brand: undefined,
      company: undefined,
      dateUpdated: new Date(),
      isGlobalAdmin: false,
      isLeader: false,
      access: [],
      emulatedUser: false,
      emulatedUserPrimaryEmail: undefined,
      employeeNumber: undefined,
      isEmployee: false,
      employeeType: undefined,
    }

    this.updateUser({ itemName: "userObject", value: userObject }, (results) => { });
    this.appLoadService.updateUserObject(userObject);

    var ssoLoggedIn = !!this.authService.getAccount();
    if (ssoLoggedIn) {
      this.authService.logout();
      this.router.navigate(['/exit'])
    } else {
      var account = this.authService.getAccount();
      this.router.navigate(['/'])
    }
  }


  deleteDraftId = (dbName, objectStore, draftId, callBack) => {


    var dbVersion: number = 1;
    switch (dbName) {
      case "EMPLOYEE_DB":
        dbVersion = this.globals.dbVersion_EMPLOYEE_DB;
        break;
      case "EMPLOYEE_INFO_DB":
        dbVersion = this.globals.dbVersion_EMPLOYEE_INFO_DB;
        break;

      //iTRAK
      case "INCIDENT_TRACKER_DB":
        dbVersion = this.globals.dbVersion_INCIDENT_TRACKER_DB;
        break;

      //HAZARD ASSESSMENTS
      case "JSA_DB":
        dbVersion = this.globals.dbVersion_JSA_DB;
        break;
      case "LOCATION_DB":
        dbVersion = this.globals.dbVersion_LOCATION_DB;
        break;
      case "POWER_FORMS_DB":
        dbVersion = this.globals.dbVersion_POWER_FORMS_DB;
        break;
      case "POWER_PORTAL_DB":
        dbVersion = this.globals.dbVersion_POWER_PORTAL_DB;
        break;
      case "PROJECT_LOG_DB":
        dbVersion = this.globals.dbVersion_PROJECT_LOG_DB;
        break;

      //PROJECTS
      case "PROJECT_DB_Qualus":
        dbVersion = this.globals.dbVersion_PROJECT_DB_Qualus;
        break;
      case "PROJECT_DB":
        dbVersion = this.globals.dbVersion_PROJECT_DB;
        break;
      case "PROJECT_DB_CE":
        dbVersion = this.globals.dbVersion_PROJECT_DB_CE;
        break;

      //SAFETY INSPECTIONS
      case "SAFETY_INSPECTIONS_DB":
        dbVersion = this.globals.dbVersion_SAFETY_INSPECTIONS_DB;
        break;
      case "SAFETY_INSPECTIONS_CATEGORIES_DB":
        dbVersion = this.globals.dbVersion_SAFETY_INSPECTIONS_DB;
        break;
      case "SAFETY_INSPECTIONS_SUB_CATEGORIES_DB":
        dbVersion = this.globals.dbVersion_SAFETY_INSPECTIONS_DB;
        break;
      case "SAFETY_INSPECTIONS_QUESTIONS_DB":
        dbVersion = this.globals.dbVersion_SAFETY_INSPECTIONS_DB;
        break;
      //SKILLS ASSESSMENT
      case "SKILLS_ASSESSMENT_DB":
        dbVersion = this.globals.dbVersion_SKILLS_ASSESSMENT_DB;
        break;
      case "SKILLS_ASSESSMENT_CATEGORIES_DB":
        dbVersion = this.globals.dbVersion_SKILLS_ASSESSMENT_DB;
        break;
      case "SKILLS_ASSESSMENT_SKILLS_DB":
        dbVersion = this.globals.dbVersion_SKILLS_ASSESSMENT_DB;
        break;
      case "TIME_EXPENSE_DB":
        dbVersion = this.globals.dbVersion_TIME_EXPENSE_DB;
        break;
    }

    var objectStoreName = objectStore;
    var storeNames = [objectStoreName];
    var db;

    if (indexedDB) {
      var request = indexedDB.open(dbName, dbVersion);

      request.onupgradeneeded = (event) => {
        var db = request.result;
      };

      var deleteData = (draftId) => {
        var transaction = db.transaction(objectStoreName, 'readwrite');

        transaction.oncomplete = (event) => {

        };

        var productsStore = transaction.objectStore(objectStoreName);

        var objectStoreRequest = productsStore.delete(draftId);
        objectStoreRequest.onsuccess = (event) => {
          callBack("Success");
        };
        objectStoreRequest.onerror = (event) => {
          callBack("Error");
        };
      };

      request.onsuccess = (event) => {
        db = request.result;
        deleteData(draftId);
      };

      request.onerror = (event) => {
        callBack("Error");
      };

    } else {
      callBack("Error");
    }

  };

  updateDraftId = (dbName, objectStore, draftId, item, callBack) => {

    var dbVersion: number = 1;
    switch (dbName) {
      case "EMPLOYEE_DB":
        dbVersion = this.globals.dbVersion_EMPLOYEE_DB;
        break;
      case "EMPLOYEE_INFO_DB":
        dbVersion = this.globals.dbVersion_EMPLOYEE_INFO_DB;
        break;

      //iTRAK
      case "INCIDENT_TRACKER_DB":
        dbVersion = this.globals.dbVersion_INCIDENT_TRACKER_DB;
        break;

      //HAZARD ASSESSMENTS
      case "JSA_DB":
        dbVersion = this.globals.dbVersion_JSA_DB;
        break;
      case "LOCATION_DB":
        dbVersion = this.globals.dbVersion_LOCATION_DB;
        break;
      case "POWER_FORMS_DB":
        dbVersion = this.globals.dbVersion_POWER_FORMS_DB;
        break;
      case "POWER_PORTAL_DB":
        dbVersion = this.globals.dbVersion_POWER_PORTAL_DB;
        break;
      case "PROJECT_LOG_DB":
        dbVersion = this.globals.dbVersion_PROJECT_LOG_DB;
        break;

      //PROJECTS
      case "PROJECT_DB_Qualus":
        dbVersion = this.globals.dbVersion_PROJECT_DB_Qualus;
        break;
      case "PROJECT_DB":
        dbVersion = this.globals.dbVersion_PROJECT_DB;
        break;
      case "PROJECT_DB_CE":
        dbVersion = this.globals.dbVersion_PROJECT_DB_CE;
        break;

      //SAFETY INSPECTIONS
      case "SAFETY_INSPECTIONS_DB":
        dbVersion = this.globals.dbVersion_SAFETY_INSPECTIONS_DB;
        break;
      case "SAFETY_INSPECTIONS_CATEGORIES_DB":
        dbVersion = this.globals.dbVersion_SAFETY_INSPECTIONS_DB;
        break;
      case "SAFETY_INSPECTIONS_SUB_CATEGORIES_DB":
        dbVersion = this.globals.dbVersion_SAFETY_INSPECTIONS_DB;
        break;
      case "SAFETY_INSPECTIONS_QUESTIONS_DB":
        dbVersion = this.globals.dbVersion_SAFETY_INSPECTIONS_DB;
        break;
      //SKILLS ASSESSMENT
      case "SKILLS_ASSESSMENT_DB":
        dbVersion = this.globals.dbVersion_SKILLS_ASSESSMENT_DB;
        break;
      case "SKILLS_ASSESSMENT_CATEGORIES_DB":
        dbVersion = this.globals.dbVersion_SKILLS_ASSESSMENT_DB;
        break;
      case "SKILLS_ASSESSMENT_SKILLS_DB":
        dbVersion = this.globals.dbVersion_SKILLS_ASSESSMENT_DB;
        break;
      case "TIME_EXPENSE_DB":
        dbVersion = this.globals.dbVersion_TIME_EXPENSE_DB;
        break;
    }

    var objectStoreName = objectStore;
    var storeNames = [objectStoreName];
    var db;

    if (indexedDB) {
      var request = indexedDB.open(dbName, dbVersion);
      request.onupgradeneeded = (event) => {
        var db = request.result;
      };
      var updateData = (draftId, item) => {
        var transaction = db.transaction(objectStoreName, 'readwrite');
        transaction.oncomplete = (event) => {
        };
        var productsStore = transaction.objectStore(objectStoreName);
        const objectStoreRequest = productsStore.put(item);
        objectStoreRequest.onsuccess = (event) => {
          callBack("Success");
        };
        objectStoreRequest.onerror = (event) => {
          callBack("Error");
        };
      };

      request.onsuccess = (event) => {
        db = request.result;
        //deleteData(draftId);
        updateData(draftId, item);
      };

      request.onerror = (event) => {
        callBack("Error");
      };

    } else {
      callBack("Error");
    }

  };

  private userObject_changed = new Subject<any>();
  get userObject_DataChanged() {
    return this.userObject_changed.asObservable();
  }
  updateUserObject(data) {
    this.userObject = data;
    this.userObject_changed.next(data);
  }



  //accessToken
  userBearerToken: string = "";
  private bearerToken_changed = new Subject<any>();
  get userBearerToken_DataChanged() {
    return this.bearerToken_changed.asObservable();
  }
  updateUserBearerToken(data) {
    this.userBearerToken = data;
    this.bearerToken_changed.next(data);
  }




  updateUser = (data, callBack) => {

    var searchString = "userObject";
    var objectStoreName = "info";
    var storeNames = [objectStoreName];

    var resultObj = {
      message: ""
    }

    if (indexedDB) {
      var request = indexedDB.open('POWER_PORTAL_DB', this.dbVersion);
      var db;

      var updateData = () => {
        var objectStore = db.transaction(objectStoreName, 'readwrite').objectStore(objectStoreName);
        var db_op_req = objectStore.put(data);
        this.updateUserObject(data.value);

        db_op_req.onsuccess = (event) => {
          resultObj.message = "success";
          callBack(resultObj);
        };
        db_op_req.onerror = (event) => {
          resultObj.message = "error";
          callBack(resultObj);
        };
      };

      request.onupgradeneeded = (event) => {
        this.upgradeNeeded(request);
      };

      request.onsuccess = (event) => {
        db = request.result;
        updateData();
      };

      request.onerror = (event) => {
        resultObj.message = "error";
        callBack(resultObj);
      };

    } else {
      resultObj.message = "notSupported";
      callBack(resultObj);
    }
  };

  getUserObject = (callBack) => {

    var itemName = "userObject";
    var objectStoreName = "info";
    var storeNames = [objectStoreName];

    var resultObj = {
      itemFound: false,
      value: ""
    }

    if (indexedDB) {
      var request = indexedDB.open('POWER_PORTAL_DB', this.dbVersion);
      var db;

      var getData = () => {

        var transaction = db.transaction(objectStoreName, 'readwrite')
        var objectStore = transaction.objectStore(objectStoreName);
        var dataResults = [];

        transaction.oncomplete = (event) => {
          callBack(resultObj);
        };


        objectStore.openCursor().onsuccess = (event) => {
          var itemFound = false;
          var cursor = event.target.result;
          if (cursor) {
            if (cursor.value.itemName.indexOf(itemName) !== -1) {
              itemFound = true;
              resultObj.itemFound = true;
              resultObj.value = cursor.value.value;
              callBack(resultObj);
            } else {
              cursor.continue();
            }
          } else {

          }

          if (!itemFound) {

          }

        };
      };

      request.onupgradeneeded = (event) => {
        /*
        db = request.result;
        if (db.objectStoreNames.contains(objectStoreName)) {
          db.deleteObjectStore(objectStoreName);
        }

        var store = db.createObjectStore(objectStoreName, {
          keyPath: "itemName"
        });
        */
      };

      request.onsuccess = (event) => {
        db = request.result;
        getData();
      };

      request.onerror = (event) => {
        callBack(resultObj);
      };

    } else {
      callBack(resultObj);
    }
  };


  capitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
  }


  escape_item_name = function (str) {
    return str.replace(/[\0\x08\x09\x1a\n\r"'\\\%]/g, function (char) {
      switch (char) {
        case "\0":
        case "\x08":
        case "\x09":
        case "\x1a":
        case "\n":
        case "\r":
        case "\"":
        case "'":
        case "\\":
        case "%":
          return "";
        // and double/single quotes
      }
    });
  };


  escape_string = function (str) {

    return str.replace(/[\0\x08\x09\x1a\n\r"'\\\%]/g, function (char) {
      switch (char) {
        case "\0":
          return "\\0";
        case "\x08":
          return "\\b";
        case "\x09":
          return "\\t";
        case "\x1a":
          return "\\z";
        case "\n":
          return "\\n";
        case "\r":
          return "\\r";
        case "\"":
        case "'":
          return "''";
        case "\\":
        case "%":
          return "\\" + char; // prepends a backslash to backslash, percent,
        // and double/single quotes
      }
    });
  };

  escape_string_SQL = function (str) {

    return str.replace(/[\0\x08\x09\x1a\n\r"'\\\%]/g, function (char) {
      switch (char) {
        case "\0":
          return "\\0";
        case "\x08":
          return "\\b";
        case "\x09":
          return "\\t";
        case "\x1a":
          return "\\z";
        case "\n":
          return "\\n";
        case "\r":
          return "\\r";
        case "\"":
          return char;
        //return "\\\\" + char;
        case "'":
          return "''";
        case "\\":
        case "%":
          return "\\" + char; // prepends a backslash to backslash, percent,
        // and double/single quotes
        //default:
        //return char;
      }
    });
  };


  escape_string_Quotes = function (str) {
    return str.replace(/\\"/g, function (char) {
      switch (char) {
        case '\"':
          return '\\"';
        default:
          return char;
        //return char;
      }
    });
  };



  escape_string_SQL_Alternate = function (str) {

    return str.replace(/[\0\x08\x09\x1a\n\r"'\\\%]/g, function (char) {
      switch (char) {
        case "\0":
          return "\\0";
        case "\x08":
          return "\\b";
        case "\x09":
          return "\\t";
        case "\x1a":
          return "\\z";
        case "\n":
          return "\\n";
        case "\r":
          return "\\r";
        //case "\"":
        // return char;
        case "'":
          return "''";
        case "\"":
          return "\\\\" + char; // prepends a backslash to backslash, percent,
        case "\\":
        case "%":
          return "\\" + char; // prepends a backslash to backslash, percent,
        // and double/single quotes
        //default:
        //return char;
      }
    });
  };


  escape_string_SQL_JSON = function (str) {
    if (typeof str != 'string')
      return str;

    return str.replace(/[\0\x08\x09\x1a\n\r"'\\\%]/g, function (char) {
      switch (char) {
        case "\0":
          return "\\0";
        case "\x08":
          return "\\b";
        case "\x09":
          return "\\t";
        case "\x1a":
          return "\\z";
        case "\n":
          return "\\n";
        case "\r":
          return "\\r";
        case "\"":
          return "''";
        //return "\_Q";
        //return char;
        //return "\\\\" + char;
        case "'":
          return "''";
        //REMOVED BELOW FOR URLs
        case "\\":
          return char;
        case "%":
          return char;

        //case "%":
        //return "\\" + char; // prepends a backslash to backslash, percent,
        //REMOVED ABOVE FOR URLs
        // and double/single quotes
        //default:
        //return char;
      }
    });
  };

  escape_string_keep_line_breaks = function (str) {

    return str.replace(/[\0\x08\x09\x1a"'\\\%]/g, function (char) {
      switch (char) {
        case "\0":
          return "\\0";
        case "\x08":
          return "\\b";
        case "\x09":
          return "\\t";
        case "\x1a":
          return "\\z";
        case "\n":
          return "\\n";
        case "\r":
          return "\\r";
        case "\"":
        case "'":
          return "''";
        case "\\":
        case "%":
          return "\\" + char; // prepends a backslash to backslash, percent,
        // and double/single quotes
      }
    });
  };

  escape_string_SQL_Remove_Apostrophe = function (str) {

    return str.replace(/[\0\x08\x09\x1a\n\r"'’\\\%]/g, function (char) {
      switch (char) {
        case "\0":
          return char;
        case "\x08":
          return char;
        case "\x09":
          return char;
        case "\x1a":
          return char;
        case "\n":
          return char;
        case "\r":
          return char;
        case "\"":
          return char;
        //return "\\\\" + char;
        case "'":
          return "";
        case "’":
          return "";
        case "\\":
          return char;
        case "%":
          return char; // prepends a backslash to backslash, percent,
        // and double/single quotes
        //default:
        //return char;
      }
    });
  };



  escape_JSON(obj) {
    Object.keys(obj).forEach((key, index) => {
      if (typeof obj[key] === 'string') {
        obj[key] = this.escape_string_SQL_JSON(obj[key]);
      }
      if (typeof obj[key] === 'object') {
        this.escape_JSON(obj[key])
      }
    })
    return obj;
  }



  getEmployeesFromServer(requestBrand = ""): Observable<any[]> {
    return Observable.create(observer => {
      this.getEmployeeList().subscribe((results) => {
        var employeeList = [];
        for (var i in results) {
          var brand = "pge"; if (results[i]["Company Code"] !== "00") { brand = "cePower"; }
          var firstName = ""; if (results[i]["First Name"]) { firstName = results[i]["First Name"]; }
          var lastName = ""; if (results[i]["Last Name"]) { lastName = results[i]["Last Name"]; }
          var employeeName = firstName + " " + lastName; employeeName = this.escape_item_name(employeeName);
          var jobTitle = ""; if (results[i]["Job Title"]) { jobTitle = results[i]["Job Title"]; };
          var emailAddress = ""; if (results[i]["Email Address"]) { emailAddress = results[i]["Email Address"]; };
          var emailAddress_Alternate = ""; if (results[i]["Alternate Email Address"]) { emailAddress_Alternate = results[i]["Alternate Email Address"] };
          var ultiproEmployeeID = ""; if (results[i].UltiproEmployeeID) { ultiproEmployeeID = results[i].UltiproEmployeeID };
          var supervisorName = ""; if (results[i]["SupervisorName"]) { supervisorName = results[i]["SupervisorName"]; };
          var supervisorEmail = ""; if (results[i]["SupervisorEmail"]) { supervisorEmail = results[i]["SupervisorEmail"]; };
          var employeeTitle = ""; if (results[i]["Job Title"]) { employeeTitle = results[i]["Job Title"]; };
          var employeeNumber = ""; if (results[i]["Employee Number"]) { employeeNumber = results[i]["Employee Number"]; };
          var employeeType = ""; if (results[i]["employeeType"]) { employeeType = results[i]["employeeType"]; };
          var isEmployee = true;
          var searchStringEmail = employeeName + " " + emailAddress;
          var searchStringNumber = employeeName + " " + emailAddress + " " + employeeNumber;

          var obj = {
            employeeName: employeeName,
            jobTitle: jobTitle,
            emailAddress: emailAddress,
            emailAddress_Alternate: emailAddress_Alternate,
            ultiproEmployeeID: ultiproEmployeeID,
            supervisorName: supervisorName,
            supervisorEmail: supervisorEmail,
            employeeTitle: employeeTitle,
            brand: brand,
            employees: [],
            employeeNumber: employeeNumber,
            searchStringEmail: searchStringEmail,
            searchStringNumber: searchStringNumber,
            employeeType: employeeType,
            isEmployee: isEmployee,
          };

          if (requestBrand === brand || requestBrand === "" || requestBrand === "All") {
            observer.next(obj);
          }
        }
        observer.complete();
      });
    })
  };




  getEmployeesFromServer_All(requestBrand): Observable<any[]> {
    return Observable.create(observer => {
      this.getEmployeeList_All().subscribe((results) => {
        var employeeList = [];
        for (var i in results) {
          var brand = "pge"; if (results[i]["Company Code"] !== "00") { brand = "cePower"; }
          var firstName = ""; if (results[i]["First Name"]) { firstName = results[i]["First Name"]; }
          var lastName = ""; if (results[i]["Last Name"]) { lastName = results[i]["Last Name"]; }
          var employeeName = firstName + " " + lastName; employeeName = this.escape_item_name(employeeName);
          var jobTitle = ""; if (results[i]["Job Title"]) { jobTitle = results[i]["Job Title"]; };
          var emailAddress = ""; if (results[i]["Email Address"]) { emailAddress = results[i]["Email Address"]; };
          var emailAddress_Alternate = ""; if (results[i]["Alternate Email Address"]) { emailAddress_Alternate = results[i]["Alternate Email Address"] };
          var ultiproEmployeeID = ""; if (results[i].UltiproEmployeeID) { ultiproEmployeeID = results[i].UltiproEmployeeID };
          var supervisorName = ""; if (results[i]["SupervisorName"]) { supervisorName = results[i]["SupervisorName"]; };
          var supervisorEmail = ""; if (results[i]["SupervisorEmail"]) { supervisorEmail = results[i]["SupervisorEmail"]; };
          var employeeTitle = ""; if (results[i]["Job Title"]) { employeeTitle = results[i]["Job Title"]; };
          var employeeNumber = ""; if (results[i]["Employee Number"]) { employeeNumber = results[i]["Employee Number"]; };

          var employeeStatusCode = ""; if (results[i]["EmploymentStatusCode"]) { employeeStatusCode = results[i]["EmploymentStatusCode"]; };

          var employeeType = ""; if (results[i]["employeeType"]) { employeeType = results[i]["employeeType"]; };
          var isEmployee = true;

          var employeeStatus = "";
          switch (employeeStatusCode) {
            case "A":
              employeeStatus = "Active";
              break;
            case "T":
              employeeStatus = "Terminated";
              break;
            case "L":
              employeeStatus = "Leave";
              break;
            default:
              break;
          }

          var searchStringEmail = employeeName + " " + emailAddress;
          var searchStringNumber = employeeName + " " + emailAddress + " " + employeeNumber;

          var obj = {
            employeeName: employeeName,
            jobTitle: jobTitle,
            emailAddress: emailAddress,
            emailAddress_Alternate: emailAddress_Alternate,
            ultiproEmployeeID: ultiproEmployeeID,
            supervisorName: supervisorName,
            supervisorEmail: supervisorEmail,
            employeeTitle: employeeTitle,
            brand: brand,
            employees: [],
            employeeNumber: employeeNumber,
            searchStringEmail: searchStringEmail,
            searchStringNumber: searchStringNumber,
            employeeStatus: employeeStatus,
            employeeType: employeeType,
            isEmployee: isEmployee,
          };

          if (requestBrand === brand || requestBrand === "" || requestBrand === "All") {
            observer.next(obj);
          }
        }
        observer.complete();
      });
    })
  };

  getUserDetails() {
    var updateUserData = false;
    var userObject: User = this.appLoadService.userObject;
    this.getUserDetailsData(userObject).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any[]) => {
      for (var i in res) {
        if (res[i].employeeNumber) {
          userObject.employeeNumber = res[i].employeeNumber
          updateUserData = true;
        }

        if (res[i].employeeType) {
          userObject.employeeType = res[i].employeeType
          if (res[i].employeeType.toLowerCase() === "s") {
            userObject.isEmployee = false;
          } else {
            userObject.isEmployee = true;
          }
          updateUserData = true;
        }

        if (res[i].systemAdmin) {
          userObject.isGlobalAdmin = res[i].systemAdmin || false;
          updateUserData = true;
        }

      }
    }, (error) => {

    }, () => {
      if (updateUserData) {
        this.updateUser({ itemName: "userObject", value: userObject }, (results) => { });
        this.appLoadService.updateUserObject(userObject);
      }
    })

  }


  userPostRequest(postData) {

    var apiURL = this.globals.apiURL_Internal_API + '/api/Users';
    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    );

    return this.http.post(apiURL, postData, {
      headers: httpHeaders
    })
  };


  getUserDetailsData(userObject: User) {
    var postData = [{
      dataRequest: "getUserDetails",
      employeeName: userObject.name,
      employeeEmail: userObject.email
    }];

    var apiURL = this.globals.apiURL_Internal_API + '/api/Users';
    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    );

    return this.http.post(apiURL, postData, {
      headers: httpHeaders
    })
  };


  getEmployeeList() {
    var postData = [{
      dataRequest: "getActiveEmployees",
    }];

    var apiURL = this.globals.apiURL_Internal_API + '/api/EmployeeList';
    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    );

    return this.http.post(apiURL, postData, {
      headers: httpHeaders
    })
  };



  getEmployeeList_All() {
    var postData = [{
      dataRequest: "getAllEmployees",
    }];

    var apiURL = this.globals.apiURL_Internal_API + '/api/EmployeeList';
    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    );

    return this.http.post(apiURL, postData, {
      headers: httpHeaders
    })
  };




  getProjectList() {
    var postData = [{
      dataRequest: "getActiveEmployees",
    }];

    var apiURL = this.globals.apiURL_Internal_API + '/api/EmployeeList';
    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    );

    return this.http.post(apiURL, postData, {
      headers: httpHeaders
    })
  };


  searchProjectList(searchString, searchLevel = "project") {
    var postData = [{
      dataRequest: "getProjectsWithClient_Qualus_Search",
      searchString: searchString,
      searchLevel: searchLevel,
    }];

    var apiURL = this.globals.apiURL_Internal_API + '/api/ProjectList_PGE';
    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    );

    return this.http.post(apiURL, postData, {
      headers: httpHeaders
    })
  };

  searchProjectList_LatLong(postData) {

    var apiURL = this.globals.apiURL_Internal_API + '/api/ProjectList_PGE';
    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    );

    return this.http.post(apiURL, postData, {
      headers: httpHeaders
    })
  };

  logError(online, module, errorDetails, sendEmail: boolean = false) {
    var removeError = false;
    var userObject = this.appLoadService.userObject;
    var employeeName = userObject.name;
    var employeeEmail = userObject.email;
    var errorDate: Date = new Date();
    var errorId = uuid();
    if (typeof errorDetails === 'object' && errorDetails !== null) {
      errorDetails = JSON.stringify(errorDetails);
    }

    var errorData: errorObject = {
      id: errorId,
      employeeEmail: employeeEmail,
      employeeName: employeeName,
      module: module,
      errorDetails: btoa(errorDetails),
      errorDate: errorDate,
      sendEmail: sendEmail
    }

    if (online) {
      if (sendEmail) {
      }

      this.uploadError(errorData, "logError").pipe(takeUntil(this.ngUnsubscribe)).subscribe((response) => {
        if (response[0].result.toLowerCase() === "success") {
          removeError = true;
        }
      }, (error) => {
        //STORE ERROR IN CACHE FOR FUTURE UPLOAD
        this.insertNewObject_Error(errorData, (results) => {
        });

      }, () => {
        if (removeError) {
          this.deleteObject_Error(errorId, (results) => {
          })
        }
      })
    } else {
      this.insertNewObject_Error(errorData, (results) => {
      });
    }
  }

  uploadError(errorData: errorObject, requestType) {
    var postData = [{
      dataRequest: "logError",
      requestType: requestType,
      employeeEmail: errorData.employeeEmail,
      employeeName: errorData.employeeName,
      errorData: btoa(JSON.stringify(errorData)),
    }];

    var apiURL = this.globals.apiURL_Internal_API + '/api/PowerPortal';
    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    );

    return this.http.post(apiURL, postData, {
      headers: httpHeaders
    })
  };


  getLastestAppVersion() {
    var postData = [{
      dataRequest: "getAppVersion",
    }];
    var apiURL = this.globals.apiURL_Internal_API + '/api/PowerPortal';
    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    );
    return this.http.post(apiURL, postData, {
      headers: httpHeaders
    })
  };


  getVersionUpdates(appVersion, userBrand) {
    var postData = [{
      dataRequest: "getVersionUpdates",
      appVersion: appVersion,
      userBrand: userBrand
    }];
    var apiURL = this.globals.apiURL_Internal_API + '/api/PowerPortal';
    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    );
    return this.http.post(apiURL, postData, {
      headers: httpHeaders
    })
  };

  checkForOutage() {
    var postData = [{
      dataRequest: "checkForOutage"
    }];

    var apiURL = this.globals.apiURL_Internal_API + '/api/PowerPortal';
    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    );

    return this.http.post(apiURL, postData, {
      headers: httpHeaders
    })
  };


  activityLog_Prank(user: User, module) {
    var employeeName = ""; if (user.name) { employeeName = user.name; }
    var employeeNumber = ""; if (user.employeeNumber) { employeeNumber = user.employeeNumber; }
    var postData = [{
      dataRequest: "insertActivityLog_FSU",
      username: user.username,
      employeeName: employeeName,
      email: user.email,
      module: module.name,
      moduleData: module.data
    }];

    var apiURL = this.globals.apiURL_Internal_API + '/api/PowerPortal';
    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    );

    return this.http.post(apiURL, postData, {
      headers: httpHeaders
    })
  };

  activityLog(user: User, module) {
    var employeeName = ""; if (user.name) { employeeName = user.name; }
    var employeeNumber = ""; if (user.employeeNumber) { employeeNumber = user.employeeNumber; }
    var postData = [{
      dataRequest: "insertActivityLog",
      username: user.username,
      employeeName: employeeName,
      email: user.email,
      module: module.name,
      moduleData: module.data,
      employeeNumber: employeeNumber,
    }];

    var apiURL = this.globals.apiURL_Internal_API + '/api/PowerPortal';
    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    );

    return this.http.post(apiURL, postData, {
      headers: httpHeaders
    })
  };


  deleteUserAccess_Tableau(ID) {
    var postData = [{
      dataRequest: "deleteUserAccess",
      ID: ID,
    }];


    var apiURL = this.globals.apiURL_Internal_API + '/api/Tableau';
    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    );

    return this.http.post(apiURL, postData, {
      headers: httpHeaders
    })

  };

  deleteUserAccess(ID) {
    var postData = [{
      dataRequest: "deleteUserAccess",
      ID: ID,
    }];


    var apiURL = this.globals.apiURL_Internal_API + '/api/PowerPortal';
    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    );

    return this.http.post(apiURL, postData, {
      headers: httpHeaders
    })

  };


  addUserAccess(postData) {
    var apiURL = this.globals.apiURL_Internal_API + '/api/PowerPortal';
    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    );
    return this.http.post(apiURL, postData, {
      headers: httpHeaders
    })
  };

  updatePushNotifications(postData) {
    var apiURL = this.globals.apiURL_Internal_API_Test + '/api/Notifications';
    //var apiURL = this.globals.apiURL_Internal_API + '/api/Notifications';
    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    );
    return this.http.post(apiURL, postData, {
      headers: httpHeaders
    })
  };


  powerPortalPostRequest(postData) {
    var apiURL = this.globals.apiURL_Internal_API + '/api/PowerPortal';

    if (postData[0].apiName) {
      apiURL = this.globals.apiURL_Internal_API + '/api/' + postData[0].apiName;
    }

    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    );
    return this.http.post(apiURL, postData, {
      headers: httpHeaders
    })
  };


  timeExpensePostRequest(postData) {
    var apiURL = this.globals.apiURL_Internal_API + '/api/TimeExpense';
    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    );
    return this.http.post(apiURL, postData, {
      headers: httpHeaders
    })
  };




  approveReportAccess(postData) {

    var apiURL = this.globals.apiURL_Internal_API + '/api/PowerPortal';
    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    );

    return this.http.post(apiURL, postData, {
      headers: httpHeaders
    })

  };


  getSystemVariable(postData) {
    var apiURL = this.globals.apiURL_Internal_API + '/api/PowerPortal';
    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    );

    return this.http.post(apiURL, postData, {
      headers: httpHeaders
    })
  };




  deleteUserFromEmailList(ID) {
    var postData = [{
      dataRequest: "deleteUserFromEmailList",
      ID: ID,
    }];


    var apiURL = this.globals.apiURL_Internal_API + '/api/PowerPortal';
    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    );

    return this.http.post(apiURL, postData, {
      headers: httpHeaders
    })

  };


  addUserToEmailList(postData) {

    var apiURL = this.globals.apiURL_Internal_API + '/api/PowerPortal';
    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    );

    return this.http.post(apiURL, postData, {
      headers: httpHeaders
    })

  };


  requestReportAccess(postData) {


    var apiURL = this.globals.apiURL_Internal_API + '/api/PowerPortal';
    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    );

    return this.http.post(apiURL, postData, {
      headers: httpHeaders
    })
  };

  getReportsForAccessList(ID) {
    var postData = [{
      dataRequest: "getReportsForAccessList",
      ID: ID,
    }];


    var apiURL = this.globals.apiURL_Internal_API + '/api/PowerPortal';
    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    );

    return this.http.post(apiURL, postData, {
      headers: httpHeaders
    })
  };

  getUsersAccess(module) {

    var postData = [{
      dataRequest: "getUserAccess",
      module: module,
    }];

    var apiURL = this.globals.apiURL_Internal_API + '/api/PowerPortal';
    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    );

    return this.http.post(apiURL, postData, {
      headers: httpHeaders
    })
  };

  manageModuleRequest(postData) {
    var apiURL = this.globals.apiURL_Internal_API + '/api/PowerPortal';
    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    );

    return this.http.post(apiURL, postData, {
      headers: httpHeaders
    })
  };


  getCurrentUsersAccess(module, userObject: User) {
    var employeeNumber = ""; if (userObject.employeeNumber) { employeeNumber = userObject.employeeNumber; }
    var postData = [{
      dataRequest: "getCurrentUsersAccess",
      module: module,
      username: userObject.email,
      employeeNumber: employeeNumber
    }];

    var apiURL = this.globals.apiURL_Internal_API + '/api/PowerPortal';
    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    );

    return this.http.post(apiURL, postData, {
      headers: httpHeaders
    })
  };

  getUserModuleAccess(user: User) {

    var employeeNumber = ""; if (user.employeeNumber) { employeeNumber = user.employeeNumber; }

    var postData = [{
      dataRequest: "getUserModuleAccess",
      username: user.email,
      employeeNumber: employeeNumber,
    }];

    var apiURL = this.globals.apiURL_Internal_API + '/api/PowerPortal';
    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    );

    return this.http.post(apiURL, postData, {
      headers: httpHeaders
    })
  };


  getCurrentUserAccess_Offline(moduleName) {
    var userObject = this.appLoadService.userObject;
    this.appLoadService.updateUserObject(userObject);
  }

  getCurrentUserAccess(moduleName) {

    var userObject = this.appLoadService.userObject;
    this.getCurrentUsersAccess(moduleName, userObject).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any[]) => {
      for (var i in res) {
        var accessLevel = res[i].accessLevel;

        var applicationAccessIndex = -1;
        for (var j in userObject.access) {
          if (userObject.access[j].applicationName === res[i].module) {
            applicationAccessIndex = parseInt(j);
            //break;
          }
        }

        var isAdmin = false;
        var isSuperAdmin = false;
        var isSuperUser = false;

        var access = [];
        if (res[i].moduleData) {
          //access = JSON.parse(response[i].moduleData)
          if (typeof res[i].moduleData === "string") {
            access = JSON.parse(res[i].moduleData);
          } else {
            access = res[i].moduleData
          }
        };


        switch (accessLevel) {
          case "admin":
            isAdmin = true;
            isSuperUser = true;

            break;
          case "superAdmin":
            isAdmin = true;
            isSuperAdmin = true;
            isSuperUser = true;
            break;

          case "superUser":
            isAdmin = false;
            isSuperAdmin = false;
            isSuperUser = true;
            break;

          default:
            isAdmin = false;
            isSuperAdmin = false;
            isSuperUser = false;
            break;
        }


        if (applicationAccessIndex > -1) {
          userObject.access[applicationAccessIndex].accessLevel = accessLevel;
          userObject.access[applicationAccessIndex].isAdmin = isAdmin;
          userObject.access[applicationAccessIndex].isSuperAdmin = isSuperAdmin;
          userObject.access[applicationAccessIndex].isSuperUser = isSuperUser;
          this.userObject.access[applicationAccessIndex].access = access;
        } else {
          var accessObj: UserAccess = {
            applicationName: res[i].module,
            accessLevel: accessLevel,
            isAdmin: isAdmin,
            isSuperAdmin: isSuperAdmin,
            isSuperUser: isSuperUser,
            access: access,
          }
          userObject.access.push(accessObj);
        }
      }
    }, (error) => {

    }, () => {
      this.updateUser({ itemName: "userObject", value: userObject }, (results) => { });
      this.appLoadService.updateUserObject(userObject);
    })

  }

  checkModuleLevelAccess(userObject: User, module: string, moduleLevel: string = "module", subModule: string = "", accessType: string = "") {
    var hasAccess = false;
    var moduleAccessIndex = userObject.access.findIndex(x => x.applicationName === module);
    if (moduleAccessIndex > -1) {
      switch (moduleLevel) {
        case "module":
          switch (accessType) {
            case "user":
            case "admin":
            case "superAdmin":
              if (userObject.access[moduleAccessIndex].accessLevel.toLowerCase() === accessType.toLowerCase()) {
                hasAccess = true;
              }
              break;
            default:
              hasAccess = true;
              break;
          }
          break;
        case "submodule":
          var subModuleAccessIndex = userObject.access[moduleAccessIndex].access.findIndex(x => x.module === subModule);
          if (subModuleAccessIndex > -1) {
            switch (accessType) {
              case "user":
              case "admin":
              case "superAdmin":
                if (userObject.access[moduleAccessIndex].access[subModuleAccessIndex].accessLevel.toLowerCase() === accessType.toLowerCase()) {
                  hasAccess = true;
                }
                break;
              default:
                hasAccess = true;
                break;
            }
          }
          break;
      }
    }
    return hasAccess;
  }



  getUserPhoto(userId: string, accessToken: string, size: string = "48x48", graphBaseUrl: string = 'https://graph.microsoft.com/v1.0') {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${accessToken}`
    });

    const url = `${graphBaseUrl}/users/${userId}/photos/${size}/$value`;
    return this.http.get(url, { headers, responseType: 'blob' });
  }


  //TESTING
  getUserImage(user): Observable<any[]> {
    return Observable.create(observer => {
      var dataRequest = "validate_external_application";

      var passwordTemp = "bearerToken";

      if (passwordTemp) {
        var postData = [{
          dataRequest: dataRequest,
          id: user.id,
        }]

        var apiURL = this.globals.apiURL_Internal_API + '/api/ValidateUser';
        const httpHeaders = new HttpHeaders(
          {
            'Content-Type': 'application/json; charset=utf-8',
            'Access-Control-Allow-Origin': '*',
            'dataType': 'json'
          }
        )

        return this.http.post(apiURL, postData, {
          headers: httpHeaders
        }).pipe(takeUntil(this.ngUnsubscribe)).subscribe(responseData => {
          if (responseData) {
            var jsonData = responseData[0];
            if (jsonData.data.authenticated) {

              var id = "123";
              var imageBlob: Blob;

              var userObject = {
                id: id,
                imageBlob: imageBlob
              }

              observer.next(userObject);
            } else {
              observer.error();
            }
          } else {
            observer.complete();
            console.log("no valid response");
          }
        }, (error) => {
          observer.error();
        }, () => {
          observer.complete();
        }
        );
      }

    });
  }

  getUserData_ExtApp(username): Observable<any[]> {

    return Observable.create(observer => {
      var dataRequest = "validate_external_application";
      var company = "PGE";
      var brand = "pge";
      this.updateItem({ itemName: "userBrand", value: "pge" }, (results) => { });
      this.updateItem({ itemName: "userCompany", value: "PGE" }, (results) => { });

      /*
      switch (brand) {
        case "pge":
          this.webWorker_PowerPortal.updateItem({ itemName: "userBrand", value: "pge" }, (results) => { });
          this.webWorker_PowerPortal.updateItem({ itemName: "userCompany", value: "PGE" }, (results) => { });
          dataRequest = "validatePGE_SSO";
          company = "PGE";
          break;
        case "cePower":
          this.webWorker_PowerPortal.updateItem({ itemName: "userBrand", value: "cePower" }, (results) => { });
          this.webWorker_PowerPortal.updateItem({ itemName: "userCompany", value: "CEPES/CEPS/RH" }, (results) => { });
          dataRequest = "validateCEP_SSO";
          company = "CEPES/CEPS/RH"
          break;
      }
      */

      var passwordTemp = "bearerToken";

      if (passwordTemp) {
        var username_Encoded = btoa(username)
        var password_Encoded = btoa(passwordTemp)
        var postData = [{
          dataRequest: dataRequest,
          username: username_Encoded,
          password: password_Encoded,
          //bearerToken: bearerToken,
        }]

        var apiURL = this.globals.apiURL_Internal_API + '/api/ValidateUser';
        const httpHeaders = new HttpHeaders(
          {
            'Content-Type': 'application/json; charset=utf-8',
            'Access-Control-Allow-Origin': '*',
            'dataType': 'json'
          }
        )

        return this.http.post(apiURL, postData, {
          headers: httpHeaders
        }).pipe(takeUntil(this.ngUnsubscribe)).subscribe(responseData => {
          if (responseData) {
            var jsonData = responseData[0];
            if (jsonData.data.authenticated) {
              var dataRequest = "checkUsername";
              var userBrand = brand;

              this.updateItem({ itemName: "userEmail", value: jsonData.data.email }, (results) => { });
              this.updateItem({ itemName: "fullname", value: jsonData.data.employeeName }, (results) => { });

              var username = ""; if (jsonData.data.username) { username = jsonData.data.username; }
              var email = ""; if (jsonData.data.email) { email = jsonData.data.email; }
              var employeeName = ""; if (jsonData.data.employeeName) { employeeName = this.escape_item_name(jsonData.data.employeeName); }
              var employeeNumber = ""; if (jsonData.data.employeeNumber) { employeeNumber = jsonData.data.employeeNumber; }
              var employeeRole = ""; if (jsonData.data.employeeRole) { employeeRole = jsonData.data.employeeRole; }
              var companyName = ""; if (jsonData.data.companyName) { companyName = jsonData.data.companyName; }
              var employeeType = ""; if (jsonData.data.employeeType) { employeeType = jsonData.data.employeeType; }
              var isEmployee = true;

              var userObject: User = {
                name: employeeName,
                username: username,
                email: email,
                brand: brand,
                company: company,
                dateUpdated: new Date(),
                isGlobalAdmin: false,
                isLeader: false,
                access: [],
                employeeNumber: employeeNumber,
                employeeRole: employeeRole,
                employeeType: employeeType,
                isEmployee: isEmployee,
                companyName: companyName,
              }

              this.updateUser({ itemName: "userObject", value: userObject }, (results) => { });
              this.appLoadService.updateUserObject(userObject);
              //this.validateToken_Ext_App(dataRequest, userBrand, userObject);
              //this.getProfileImage(bearerToken, userObject);
              observer.next(userObject);
            } else {
              observer.error();
            }
          } else {
            observer.complete();
            console.log("no valid response");
          }
        }, (error) => {
          observer.error();
        }, () => {
          observer.complete();
        }
        );
      }

    });
  };

  validateToken_Ext_App(dataRequest: string, userBrand: string, userObject: User) {
    /*
    var isAuthenticated = this.pgeToken.validateToken(dataRequest, userObject.username);
    if (isAuthenticated) {
      var dataObj = { itemName: "username", value: userObject.username };
      this.updateItem(dataObj, (results) => { });
      var moduleData = {
        name: "Power Portal Sign In",
        data: ""
      }

      var profileData = {
        ID: 0,
        role: "",
        createdByName: userObject.name,
        createdByEmail: userObject.email,
        employeeEmail_Alternate: "",
        moduleData: undefined,
        employeeNumber: userObject.employeeNumber,
        employeeRole: userObject.employeeRole,
      }
      this.updateUserProfile(userObject, "update_last_login", profileData).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res) => {
        //this.isLoading = true;
        //
        this.router.navigate(['/home'], { relativeTo: this.route }).then(nav => {
        }, err => {
          console.log("Error: " + err)
        })
        //
      })

      var profileData = {
        ID: 0,
        role: "",
        createdByName: userObject.name,
        createdByEmail: userObject.email,
        employeeEmail_Alternate: "",
        moduleData: undefined,
        employeeNumber: userObject.employeeNumber,
        employeeRole: userObject.employeeRole,
      }
      this.updateUserProfile(userObject, "update_last_login", profileData)
    }
    */
  }


  //GETS AND UPDATES USER TOTAL ACCESS, WITH CALL BACK TO SPECIFIC MODULE IF NEEDED 12-10-2023
  getCurrentUserAccessModuleAccess(moduleName, callBack) {




    var userObject = this.appLoadService.userObject;

    this.getModuleList(userObject);

    this.getUserModuleAccess(userObject).subscribe((response) => {

      if (response[0].data) {
        if (response[0].data.message) {
          var errorObj = {
            showError: true,
            message: response[0].data.message
          }
        }
      } else {

        for (var r in response) {

          var accessLevel = response[r].accessLevel;
          var applicationAccessIndex = -1;
          for (var i in userObject.access) {
            if (userObject.access[i].applicationName === response[r].module) {
              applicationAccessIndex = parseInt(i);
              break;
            }
          }

          var isAdmin = false;
          var isSuperAdmin = false;
          var isSuperUser = false;

          var access = [];
          if (response[r].moduleData) {
            //access = JSON.parse(response[i].moduleData)
            if (typeof response[r].moduleData === "string") {
              access = JSON.parse(response[r].moduleData);
            } else {
              access = response[r].moduleData
            }
          };

          switch (accessLevel) {
            case "admin":
              isAdmin = true;
              isSuperAdmin = false;
              isSuperUser = true;

              break;
            case "superAdmin":
              isAdmin = true;
              isSuperAdmin = true;
              isSuperUser = true;
              break;
            case "superUser":
              isAdmin = false;
              isSuperAdmin = false;
              isSuperUser = true;
              break;
            default:
              isAdmin = false;
              isSuperAdmin = false;
              isSuperUser = false;
              break;
          }

          if (applicationAccessIndex > -1) {
            userObject.access[applicationAccessIndex].accessLevel = accessLevel;
            userObject.access[applicationAccessIndex].isAdmin = isAdmin;
            userObject.access[applicationAccessIndex].isSuperAdmin = isSuperAdmin;
            userObject.access[applicationAccessIndex].isSuperUser = isSuperUser;
            userObject.access[applicationAccessIndex].access = access;
          } else {
            var accessObj: UserAccess = {
              applicationName: response[r].module,
              accessLevel: accessLevel,
              isAdmin: isAdmin,
              isSuperAdmin: isSuperAdmin,
              isSuperUser: isSuperUser,
              access: access,
            }
            userObject.access.push(accessObj);
          }
        }
      }
    }, (error) => {

    }, () => {

      this.updateUser({ itemName: "userObject", value: userObject }, (results) => { });
      userObject = this.appLoadService.userObject;
      this.appLoadService.updateUserObject(userObject);
      var moduleAccess: any;
      for (var i in userObject.access) {
        if (userObject.access[i].applicationName === moduleName) {
          moduleAccess = userObject.access[i]
        }
      };
      callBack(moduleAccess);
    })
  }

  updateUserModuleAccess(moduleName, callBack) {

    var userObject = this.appLoadService.userObject;

    this.getUserModuleAccess(userObject).subscribe((response: any) => {

      if (response[0].data) {
        if (response[0].data.message) {
          var errorObj = {
            showError: true,
            message: response[0].data.message
          }
        }
      } else {

        //REMOVE ACCESS
        for (var i in userObject.access) {
          var keepIndex = response.findIndex(aObject => aObject.module === userObject.access[i].applicationName)
          if (keepIndex < 0) {
            userObject.access.splice(parseInt(i), 1);
          }
        }

        for (var i in response) {

          var accessLevel = response[i].accessLevel;
          var isAdmin = false;
          var isSuperAdmin = false;
          var isSuperUser = false;

          var access = []; if (response[i].moduleData) { access = JSON.parse(response[i].moduleData) };

          var applicationAccessIndex = -1;
          for (var k in userObject.access) {
            if (userObject.access[k].applicationName === response[i].module) {
              applicationAccessIndex = parseInt(k);
            }
          }

          switch (accessLevel) {
            case "admin":
              isAdmin = true;
              break;
            case "superAdmin":
              isAdmin = true;
              isSuperAdmin = true;
              isSuperUser = true;
              break;

            case "superUser":
              isAdmin = false;
              isSuperAdmin = false;
              isSuperUser = true;
              break;

            default:
              isAdmin = false;
              isSuperAdmin = false;
              isSuperUser = false;
              break;
          }

          if (applicationAccessIndex > -1) {
            userObject.access[applicationAccessIndex].accessLevel = accessLevel;
            userObject.access[applicationAccessIndex].isAdmin = isAdmin;
            userObject.access[applicationAccessIndex].isSuperAdmin = isSuperAdmin;
            userObject.access[applicationAccessIndex].isSuperUser = isSuperUser;
            userObject.access[applicationAccessIndex].access = access;
          } else {
            var accessObj: UserAccess = {
              applicationName: response[i].module,
              accessLevel: accessLevel,
              isAdmin: isAdmin,
              isSuperAdmin: isSuperAdmin,
              isSuperUser: isSuperUser,
              access: access,
            }
            userObject.access.push(accessObj);
          }

          /*
          this.updateUser({ itemName: "userObject", value: userObject }, (results) => { });
          this.appLoadService.updateUserObject(userObject);
          */
        }
      }
    }, (error) => {

    }, () => {


      this.updateUser({ itemName: "userObject", value: userObject }, (results) => { });
      userObject = this.appLoadService.userObject;
      this.appLoadService.updateUserObject(userObject);
      var moduleAccess: any;
      for (var i in userObject.access) {
        if (userObject.access[i].applicationName === moduleName) {
          moduleAccess = userObject.access[i]
        }
      };
      callBack(moduleAccess);

    })
  }

  getUsersAccess_Reports_List(postData) {
    var apiURL = this.globals.apiURL_Internal_API + '/api/PowerPortal';
    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    );

    return this.http.post(apiURL, postData, {
      headers: httpHeaders
    })
  };

  getUsersAccess_Reports_All(module) {
    var postData = [{
      dataRequest: "getUserAccess_Reports",
      module: module,
    }];
    var apiURL = this.globals.apiURL_Internal_API + '/api/PowerPortal';
    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    );

    return this.http.post(apiURL, postData, {
      headers: httpHeaders
    })

  }

  getReportOptionsForModule(module) {

    var postData = [{
      dataRequest: "getReportOptionsForModule",
      module: module,
    }];

    var apiURL = this.globals.apiURL_Internal_API + '/api/PowerPortal';
    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    );

    return this.http.post(apiURL, postData, {
      headers: httpHeaders
    })
  };


  private userEmailReport_Options_Data_changed = new Subject<any>();
  get getUserEmailReportList_Options() {
    return this.userEmailReport_Options_Data_changed.asObservable();
  }
  updateData_EmailReportList_Options(data) {
    this.userEmailReport_Options_Data_changed.next(data);
  }


  getReportEmailList(module) {

    var postData = [{
      dataRequest: "getReportEmailList",
      module: module,
    }];

    var apiURL = this.globals.apiURL_Internal_API + '/api/PowerPortal';
    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    );

    return this.http.post(apiURL, postData, {
      headers: httpHeaders
    })
  };

  private userEmailReport_Data_changed = new Subject<any>();
  get getUserEmailReportList() {
    return this.userEmailReport_Data_changed.asObservable();
  }
  updateData_EmailReportList(data) {
    this.userEmailReport_Data_changed.next(data);
  }


  private itemKeyObjectList_Data_changed = new Subject<any>();
  get getData_ItemKeyObjectList() {
    return this.itemKeyObjectList_Data_changed.asObservable();
  }
  updateData_ItemKeyObjectList(data) {
    this.itemKeyObjectList_Data_changed.next(data);
  }



  getUsersAccess_Unbilled(userObject: User) {
    var employeeNumber = ""; if (userObject.employeeNumber) { employeeNumber = userObject.employeeNumber; }

    var postData = [{
      dataRequest: "getUnbilledAccess",
      username: userObject.username,
      employeeNumber: employeeNumber,
    }];


    var apiURL = this.globals.apiURL_Internal_API + '/api/PowerPortal';
    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    );

    return this.http.post(apiURL, postData, {
      headers: httpHeaders
    })
  };



  updateUserProfile(userObject: User, requestType: string, data: any) {

    var ID = 0; if (data.ID) { ID = data.ID; }
    var role = ""; if (data.role) { role = data.role; }
    var createdByName = ""; if (data.createdByName) { createdByName = data.createdByName; }
    var createdByEmail = ""; if (data.createdByEmail) { createdByEmail = data.createdByEmail; }
    var employeeEmail_Alternate = ""; if (data.employeeEmail_Alternate) { employeeEmail_Alternate = data.employeeEmail_Alternate; }
    var moduleData = '[]'; if (data.moduleData) { moduleData = JSON.stringify(data.moduleData); }
    var employeeNumber = ""; if (userObject.employeeNumber) { employeeNumber = userObject.employeeNumber; }
    var roleId = 0; if (data.roleId) { roleId = data.roleId; }
    var postData = [{
      dataRequest: "PowerPortal_manage_users",
      username: userObject.username,
      employeeName: userObject.name,
      employeeEmail: userObject.email,
      employeeEmail_Alternate: employeeEmail_Alternate,
      brand: userObject.brand,
      company: userObject.company,
      requestType: requestType,
      ID: ID,
      role: role,
      createdByName: data.createdByName,
      createdByEmail: data.createdByEmail,
      moduleData: moduleData,
      employeeNumber: employeeNumber,
      roleId: roleId,
    }];

    var apiURL = this.globals.apiURL_Internal_API + '/api/Users';
    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    );

    return this.http.post(apiURL, postData, {
      headers: httpHeaders
    })
  };

  getUsersAccess_Reports(userObject: User) {
    var employeeNumber = ""; if (userObject.employeeNumber) { employeeNumber = userObject.employeeNumber; }
    var postData = [{
      dataRequest: "getReportsAccess",
      email: userObject.email,
      employeeNumber: employeeNumber,
    }];


    var apiURL = this.globals.apiURL_Internal_API + '/api/PowerPortal';
    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    );

    return this.http.post(apiURL, postData, {
      headers: httpHeaders
    })
  };

  getUsersRole_Forms(userObject: User) {

    var employeeNumber = ""; if (userObject.employeeNumber) { employeeNumber = userObject.employeeNumber; }

    var postData = [{
      dataRequest: "getUsersRoleForms",
      email: userObject.email,
      employeeNumber: employeeNumber,
    }];

    var apiURL = this.globals.apiURL_Internal_API + '/api/PowerPortal';
    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    );

    return this.http.post(apiURL, postData, {
      headers: httpHeaders
    })

  };

  getUsersToolBox(userObject: User) {

    var employeeNumber = ""; if (userObject.employeeNumber) { employeeNumber = userObject.employeeNumber; }

    var postData = [{
      dataRequest: "getUsersToolBox",
      email: userObject.email,
      employeeNumber: employeeNumber,
    }];

    var apiURL = this.globals.apiURL_Internal_API + '/api/PowerPortal';
    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    );

    return this.http.post(apiURL, postData, {
      headers: httpHeaders
    })

  };

  getUsersApprovals(userObject: User) {

    var employeeNumber = ""; if (userObject.employeeNumber) { employeeNumber = userObject.employeeNumber; }

    var postData = [{
      dataRequest: "getUsersApprovals",
      email: userObject.email,
      employeeNumber: employeeNumber,
    }];

    var apiURL = this.globals.apiURL_Internal_API + '/api/PowerPortal';
    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    );

    return this.http.post(apiURL, postData, {
      headers: httpHeaders
    })

  };



  getUsersAssignments(userObject: User) {
    var employeeNumber = ""; if (userObject.employeeNumber) { employeeNumber = userObject.employeeNumber; }
    var postData = [{
      dataRequest: "getUserAssignments", //"getUsersApprovals", // "getUserAssignments",
      email: userObject.email,
      employeeNumber: employeeNumber,
    }];

    var apiURL = this.globals.apiURL_Internal_API + '/api/PowerPortal';
    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    );
    return this.http.post(apiURL, postData, {
      headers: httpHeaders
    })
  };


  addTableauUserAccess(postData) {
    var apiURL = this.globals.apiURL_Internal_API + '/api/Tableau';
    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    );
    return this.http.post(apiURL, postData, {
      headers: httpHeaders
    })

  };

  updateUsersAccess_Reports(postData) {
    var apiURL = this.globals.apiURL_Internal_API + '/api/Tableau';

    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    );

    return this.http.post(apiURL, postData, {
      headers: httpHeaders
    })
  };





  private userAccess_Data_changed_itrak = new Subject<any>();
  get getUserAccessData_iTrak() {
    return this.userAccess_Data_changed_itrak.asObservable();
  }
  updateData_UserAccessItrak(data) {
    this.userAccess_Data_changed_itrak.next(data);
  }



  private unbilledAccess_Data_changed = new Subject<any>();
  get get_unbilled_Access() {
    return this.unbilledAccess_Data_changed.asObservable();
  }
  update_Unbilled_Access(data) {
    this.unbilledAccess_Data_changed.next(data);
  }


  private reportsAccess_Data_changed = new Subject<any>();
  get get_reports_Access() {
    return this.reportsAccess_Data_changed.asObservable();
  }
  update_Reports_Access(data) {
    this.reportsAccess_Data_changed.next(data);
  }



  private userToolBox_Data_changed = new Subject<any>();
  get get_user_toolbox() {
    return this.userToolBox_Data_changed.asObservable();
  }
  update_user_toolbox(data) {
    this.userToolBox_Data_changed.next(data);
  }




  private userApprovals_Data_changed = new Subject<any>();
  get get_user_my_approvals() {
    return this.userApprovals_Data_changed.asObservable();
  }
  update_user_my_approvals(data) {
    this.userApprovals_Data_changed.next(data);
  }


  private userAssignments_Data_changed = new Subject<any>();
  get get_user_my_assignments() {
    return this.userAssignments_Data_changed.asObservable();
  }
  update_user_my_assignments(data) {
    this.userAssignments_Data_changed.next(data);
  }


  private userRecentURL_Locations_Data_changed = new Subject<any>();
  get get_user_recent_url_locations() {
    return this.userRecentURL_Locations_Data_changed.asObservable();
  }
  update_user_recent_url_locations(data) {
    this.userRecentURL_Locations_Data_changed.next(data);
  }



  private modulesAccess_Data_changed = new Subject<any>();
  get get_modules_Access() {
    return this.modulesAccess_Data_changed.asObservable();
  }
  update_Modules_Access(data) {
    this.modulesAccess_Data_changed.next(data);
  }


  screenSizeObj = {
    showSmallScreen: false,
    screenSize: "large",
  }

  screenSize: any;

  private showSmallScreen_Data_Changed = new Subject<any>();
  get get_showSmallScreen() {
    return this.showSmallScreen_Data_Changed.asObservable();
  }
  update_showSmallScreen(data) {
    this.screenSizeObj = data;
    this.showSmallScreen_Data_Changed.next(data);
  }


  private screenSize_Data_Changed = new Subject<any>();
  get get_screenScreen() {
    return this.screenSize_Data_Changed.asObservable();
  }
  update_screenSize(data) {
    this.screenSize = data;
    this.screenSize_Data_Changed.next(data);
  }



  appendClass(value, newClass) {
    if (value === "") {
      return newClass;
    } else {
      return value + " " + newClass;
    }
  }

  public showMessage(message, width = "350px", height = "350px") {
    this.zone.run(() => {
      const dialogRef = this.dialog.open(MessageDialogComponent, {
        width: width,
        data: message
      });
      dialogRef.afterClosed().pipe(takeUntil(this.ngUnsubscribe)).subscribe(result => {
        if (result) {

        }
      });
    });
  }

  public showMessageCustom(message) {
    var messageData = {
      message: message,
    }
    this.zone.run(() => {
      const dialogRef = this.dialog.open(AlertMessageCustomComponent, {
        width: '350px',
        data: messageData
      });
      dialogRef.afterClosed().pipe(takeUntil(this.ngUnsubscribe)).subscribe(result => {
        if (result) {

        }
      });
    });
  }



  public showTopMessage(severity, summary, detail, life) {
    this.zone.run(() => {
      this.messageService.add({ severity: severity, summary: summary, detail: detail, life: life });
    });
  }


  public showAlertBar(message, action = 'success', horizontalPosition: MatSnackBarHorizontalPosition = "center", verticalPosition: MatSnackBarVerticalPosition = "top", duration = 50000, panelClass = "lightgray-snackbar") {
    this.zone.run(() => {
      this._snackBar.open(message, action, {
        duration: duration,
        horizontalPosition: horizontalPosition,
        verticalPosition: verticalPosition,
        panelClass: [panelClass]
      });

    });
  }

  public dismissAlert() {
    this.zone.run(() => {

    })
  }





  //DOWNLOAD FAQ DOCUMENT FOR MODULE

  getFAQ_Document(module) {

    const returnObs = new Observable(observer => {



      var reportName = "getWorkInstructions";

      switch (module.value) {
        case "itrak":
          this.getFileData(reportName, "iTrak", "powerPortal_iTrak_instructions").pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
            observer.next(res);
          }, (error) => {
            observer.complete();
          }, () => {
            observer.complete();
          });
          break;

        case "safetyReporting":
          this.getFileData(reportName, "safetyInspections", "powerPortal_Safety_Inspections_instructions").pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
            observer.next(res);
          }, (error) => {
            observer.complete();
          }, () => {
            //observer.complete();
          });
          break;

        case "projectManagement/projectLog":
        case "projectLog":
          this.getFileData(reportName, "projectLog", "powerPortal_Project_Log_instructions").pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
            observer.next(res);
          }, (error) => {
            observer.complete();
          }, () => {
            observer.complete();
          });
          break;

        case "skillsAssessment":
          this.getFileData(reportName, "skillsAssessment", "powerPortal_Skills_Assessment_instructions").pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
            observer.next(res);
          }, (error) => {
            observer.complete();
          }, () => {
            observer.complete();
          });
          break;

        case "hazardAssessment":
          this.getFileData(reportName, "hazardAssessment", "powerPortal_Hazard_Assessment_instructions").pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
            observer.next(res);
          }, (error) => {
            observer.complete();
          }, () => {
            observer.complete();
          });
          break;

        case "unbilled":
          this.getFileData(reportName, "unbilled", "powerPortal_Unbilled_instructions").pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
            observer.next(res);
          }, (error) => {
            observer.complete();
          }, () => {
            observer.complete();
          });
          break;

        case "billing":
          this.getFileData(reportName, "billing", "powerPortal_Unbilled_instructions").pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
            observer.next(res);
          }, (error) => {
            observer.complete();
          }, () => {
            observer.complete();
          });
          break;

        case "reports":
          this.getFileData(reportName, "reports", "powerPortal_Reports_instructions").pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
            observer.next(res);
          }, (error) => {
            observer.complete();
          }, () => {
            observer.complete();
          });
          break;

        case "timeSheetValidation":
          this.getFileData(reportName, "timeSheetValidation", "powerPortal_Timesheet_Validation").pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
            observer.next(res);
          }, (error) => {
            observer.complete();
          }, () => {
            observer.complete();
          });
          break;
        case "deltekMobile":
          this.getFileData(reportName, "deltekMobile", "powerPortal_DeltekMobile").pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
            observer.next(res);
          }, (error) => {
            observer.complete();
          }, () => {
            observer.complete();
          });
          break;
        case "forms":
          this.getFileData(reportName, "PowerForms", "powerPortal_PowerForms").pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
            observer.next(res);
          }, (error) => {
            observer.complete();
          }, () => {
            observer.complete();
          });
          break;
        case "ezInventory":
          this.getFileData(reportName, "PowerForms", "powerPortal_EZInventory").pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
            observer.next(res);
          }, (error) => {
            observer.complete();
          }, () => {
            observer.complete();
          });
          break;

        case "document_ExpenseBulkUpload":
          this.getFileData(reportName, "document_ExpenseBulkUpload", "ExpenseBulkUpload").pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
            observer.next(res);
          }, (error) => {
            observer.complete();
          }, () => {
            observer.complete();
          });
          break;

        default:
          this.showAlert({ message: "FAQ does not exist for this module.", severity: "error" })
          observer.complete();
          break;
      }
    });

    return returnObs;
  }

  getFileData(reportName: string, module: string, filename: string) {
    const returnObs = new Observable(observer => {

      var returnData = {
        success: false
      }

      var apiURL = this.globals.apiURL_Internal_API + '/api/PowerPortalReports';

      var postData = [{
        reportName: reportName,
        module: module
      }]

      const httpHeaders = new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Access-Control-Allow-Origin': '*',
          'dataType': 'json'
        }
      )
      return this.http.post(apiURL, postData, {
        responseType: "arraybuffer",
        headers: httpHeaders

      }).pipe(takeUntil(this.ngUnsubscribe)).subscribe(response => {
        this.fileService.downLoadFile(response, "application/pdf", filename)
        returnData.success = true;
        observer.next(returnData);
        observer.complete();
      }, (error) => {
        this.fileService.handleError(error);
        observer.next(returnData);
        observer.complete();
      });

    });
    return returnObs;
  }




  downloadDocumentReport(reportName: string, fileName: string, htmlContent: string, mediaType: string) {
    //this.isLoading = true;
    var apiURL = this.globals.apiURL_Internal_API + '/api/PowerPortalReports';
    var htmlEncoded = "";

    try {
      htmlEncoded = btoa(htmlContent);
    } catch (error) {
      htmlEncoded = btoa(unescape(encodeURIComponent(htmlContent)));
    }

    //reportName = "getWorkInstructions";
    var module = ""; //"safetyInspections"
    var postData = [{
      reportName: reportName,
      module: module,
      fileName: fileName,
      htmlContent: htmlEncoded,
    }]

    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    )
    return this.http.post(apiURL, postData, {
      responseType: "arraybuffer",
      headers: httpHeaders
    }).pipe(takeUntil(this.ngUnsubscribe)).subscribe(response => this.downLoadFile(response, fileName, mediaType), error => this.handleError(error));
  }


  downloadCustomDocumentReport(reportName: string, fileName: string, jsonVariablesObject: documentAnswerSchema[], mediaType: string, template) {

    //JARED UPDATE BEFORE PROD 8-29-2024
    //var apiURL = this.globals.apiURL_Internal_API + '/api/PowerPortalReports';
    var apiURL = this.globals.apiURL_Internal_API_Test + '/api/PowerPortalReports';

    var jsonVariables_Encoded = "";
    var jsonVariables = JSON.stringify(jsonVariablesObject);

    //requestDataEncoded = JSON.stringify(requestData);
    //requestDataEncoded = this.escape_string_SQL_Remove_Apostrophe(requestDataEncoded);

    try {
      jsonVariables_Encoded = btoa(jsonVariables);
    } catch (error) {
      jsonVariables_Encoded = btoa(unescape(encodeURIComponent(jsonVariables)));
    }

    //reportName = "getWorkInstructions";
    var module = ""; //"safetyInspections"
    var postData = [{
      reportName: reportName,
      module: module,
      fileName: fileName,
      jsonVariables: jsonVariables_Encoded,
      templateId: template.id
    }]

    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    )
    return this.http.post(apiURL, postData, {
      responseType: "arraybuffer",
      headers: httpHeaders
    }).pipe(takeUntil(this.ngUnsubscribe)).subscribe(response => this.downLoadFile(response, fileName, mediaType), error => this.handleError(error));
  }



  downloadCustomDocumentReportTemplate(reportName: string, fileName: string, jsonVariablesObject: any[], mediaType: string, template) {

    //JARED UPDATE BEFORE PROD 8-29-2024
    //var apiURL = this.globals.apiURL_Internal_API + '/api/PowerPortalReports';
    var apiURL = this.globals.apiURL_Internal_API_Test + '/api/PowerPortalReports';

    var jsonVariables_Encoded = "";
    var jsonVariables = JSON.stringify(jsonVariablesObject);

    //requestDataEncoded = JSON.stringify(requestData);
    //requestDataEncoded = this.escape_string_SQL_Remove_Apostrophe(requestDataEncoded);

    try {
      jsonVariables_Encoded = btoa(jsonVariables);
    } catch (error) {
      jsonVariables_Encoded = btoa(unescape(encodeURIComponent(jsonVariables)));
    }

    //reportName = "getWorkInstructions";
    var module = ""; //"safetyInspections"
    var postData = [{
      reportName: reportName,
      module: module,
      fileName: fileName,
      jsonVariables: jsonVariables_Encoded,
      templateId: template.id
    }]

    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    )
    return this.http.post(apiURL, postData, {
      responseType: "arraybuffer",
      headers: httpHeaders
    }).pipe(takeUntil(this.ngUnsubscribe)).subscribe(response => this.downLoadFile(response, fileName, mediaType), error => this.handleError(error));
  }


  downloadCustomDocumentReportTemplate_Test(reportName: string, fileName: string, jsonVariablesObject: any[], mediaType: string, template) {

    //JARED UPDATE BEFORE PROD 8-29-2024
    //var apiURL = this.globals.apiURL_Internal_API + '/api/PowerPortalReports';
    var apiURL = this.globals.apiURL_LocalHost + '/api/PowerPortalReports';

    var jsonVariables_Encoded = "";
    var jsonVariables = JSON.stringify(jsonVariablesObject);

    //requestDataEncoded = JSON.stringify(requestData);
    //requestDataEncoded = this.escape_string_SQL_Remove_Apostrophe(requestDataEncoded);

    try {
      jsonVariables_Encoded = btoa(jsonVariables);
    } catch (error) {
      jsonVariables_Encoded = btoa(unescape(encodeURIComponent(jsonVariables)));
    }

    //reportName = "getWorkInstructions";
    var module = ""; //"safetyInspections"
    var postData = [{
      reportName: reportName,
      module: module,
      fileName: fileName,
      jsonVariables: jsonVariables_Encoded,
      templateId: template.id
    }]

    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    )
    return this.http.post(apiURL, postData, {
      responseType: "arraybuffer",
      headers: httpHeaders
    }).pipe(takeUntil(this.ngUnsubscribe)).subscribe(response => this.downLoadFile(response, fileName, mediaType), error => this.handleError(error));
  }


  downloadTemplate_CustomDocument(reportName: string, fileName: string, mediaType: string, template) {

    //JARED UPDATE BEFORE PROD 8-29-2024
    //var apiURL = this.globals.apiURL_Internal_API + '/api/PowerPortalReports';
    var apiURL = this.globals.apiURL_Internal_API_Test + '/api/PowerPortalReports';

    var jsonVariables = '[]';
    var jsonVariables_Encoded = "";
    try {
      jsonVariables_Encoded = btoa(jsonVariables);
    } catch (error) {
      jsonVariables_Encoded = btoa(unescape(encodeURIComponent(jsonVariables)));
    }

    //reportName = "getWorkInstructions";
    var module = ""; //"safetyInspections"
    var postData = [{
      reportName: reportName,
      module: module,
      fileName: fileName,
      jsonVariables: jsonVariables_Encoded,
      templateId: template.id
    }]

    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'dataType': 'json'
      }
    )
    return this.http.post(apiURL, postData, {
      responseType: "arraybuffer",
      headers: httpHeaders
    }).pipe(takeUntil(this.ngUnsubscribe)).subscribe(response => this.downLoadFile(response, fileName, mediaType), error => this.handleError(error));
  }


  private handleError(error: HttpErrorResponse) {
    //this.isLoading = false;
    this.showAlert({ message: "Error downloading Report", severity: "error" })
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    } else {
      console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
    }
  }

  downLoadFile(data: any, filename: string, mediaType: string) {
    var blob = new Blob([data], { type: mediaType });
    FileSaver.saveAs(blob, filename);
    //this.isLoading = false;
  }


  docCreator_ReplaceHTML_With_Answer_Table(htmlString: string, answerSchema: documentAnswerSchema[]) {
    const htmlObj = cheerio.load(htmlString);

    htmlObj('*').find('*').each((index, element) => {
      const $element = htmlObj(element);
      const element_Table = $element.attr('data-table');

      const element_Table_Loop = $element.attr('data-row-loop');
      if (element_Table_Loop) {
        //EMPTY ELEMENTS CHILDREN

        const tableMatchLoop = element_Table_Loop.match(/\{!(.*?)\}/);
        if (tableMatchLoop) {
          const tableMatchColumn = tableMatchLoop[1];

          const schema = answerSchema.find(item => item.column === tableMatchColumn);
          if (schema) {
            var replacedHtml_Body = "";

            //CHECK IF THE SCHEMA COLUMN HAS 'TABLEDATA'
            if (schema.tableData) {

              for (var i in schema.tableData) {
                var replacedHtml_Row = $element.html().toString(); //WAS WORKING FINE
                //const tableMatches = $element.text().match(/\{!(.*?)\}/g); //CHECK THE TEXT, NOT THE ELEMENT PROPERTIES  //WAS WORKING FINE

                var tableMatches = $element.text().match(/\{!(.*?)\}/g); //CHECK THE TEXT, NOT THE ELEMENT PROPERTIES

                switch (schema.tableData[i].questionType) {
                  //ORIGINAL WAY - WORKING

                  case "Image":
                    tableMatches = $element.html().match(/\{!(.*?)\}/g); //CHECK THE TEXT, NOT THE ELEMENT PROPERTIES
                  /*
                  if (tableMatches) {
                    tableMatches.forEach((match) => {
                      const tableRowColumn = match.substr(2, match.length - 3);
                      var tableRowColumnAnswer = schema.tableData[i].answer;
                      replacedHtml_Row = replacedHtml_Row.replace(new RegExp(`\\{!${tableRowColumn}\\}`, "g"), tableRowColumnAnswer);
                    });
                  }

                  break;
                */

                  //FOR REGULAR TABLE UPDATES
                  default:

                    if (tableMatches) {
                      tableMatches.forEach((match) => {
                        const tableRowColumn = match.substr(2, match.length - 3);

                        for (var ti in schema.tableData[i].rowAnswers) {
                          console.log("Row Test");

                          const tableRowColumnIndex = schema.tableData[i].rowAnswers.findIndex(r => r.column === tableRowColumn);

                          if (tableRowColumnIndex > -1) {
                            var tableRowColumnAnswer = schema.tableData[i].rowAnswers[tableRowColumnIndex].answer;

                            switch (schema.tableData[i].rowAnswers[tableRowColumnIndex].questionType) {

                              case "Date":
                                console.log("Table Row is Date: " + tableRowColumnAnswer);
                                if (tableRowColumnAnswer && tableRowColumnAnswer !== "") {
                                  tableRowColumnAnswer = this.formatDate_MM_DD_YYYY(new Date(tableRowColumnAnswer))
                                }

                                break;
                              case "File Link":
                                console.log("Table Row is File Link: " + tableRowColumnAnswer);
                                if (tableRowColumnAnswer && tableRowColumnAnswer !== "") {
                                  //tableRowColumnAnswer = this.formatDate_MM_DD_YYYY(new Date(tableRowColumnAnswer))
                                  var documentLink = tableRowColumnAnswer;
                                  var documentName = "Google";
                                  tableRowColumnAnswer = '<a href="' + documentLink + '" target="_blank">Download</a>';
                                  //tableRowColumnAnswer = '<a href="' + documentLink + '" target="_blank">' + documentName + '</a>'
                                }

                                break;
                              case "Attachment":
                                break;
                              case "Data Upload":
                                break;
                              case "Table":
                                break;
                              case "Image":
                              case "Multiple Choice":
                              case "Multiple Selection":
                              case "Number":
                              case "Time":
                              case "Text Box":
                              case "Text Field":
                              case "True/False":
                              case "HTML Text Box":
                              default:

                                break;
                            }

                            replacedHtml_Row = replacedHtml_Row.replace(new RegExp(`\\{!${tableRowColumn}\\}`, "g"), tableRowColumnAnswer);
                          }

                          //const tableRowColumn

                          //GET THE ANSWER FOR THE ROW IN THE TABLE DATA
                          //var tableDataAnswer = schema.tableData[i][tableColumn];
                          //if (tableDataAnswer) {

                          //replacedHtml_Row = replacedHtml_Row.replace(new RegExp(`\\{!${tableColumn}\\}`, "g"), tableDataAnswer);

                          //const replacedHtml_Row_New = replacedHtml_Row_Placeholder.replace(new RegExp(`\\{!${tableColumn}\\}`, "g"), tableDataAnswer); //TEST THIS
                          //replacedHtml_Row = replacedHtml_Row + replacedHtml_Row_New; //TEST THIS
                          /*
                          if (parseFloat(i) === 0) {
                            $element.html(replacedHtml_Table);
                          } else {
                            $element.after(replacedHtml_Table);
                          }
                          */
                          //}
                        }




                        /*
                        if (tableSchema) {
                          const answer = schema.answer;
                          const replacedHtml = $element.html().replace(new RegExp(`\\{!${tableColumn}\\}`, "g"), answer);
                          $element.html(replacedHtml);
                        }
                        */
                      });
                    }

                    break;
                }



                //MERGE THE HTML FOR ALL ROWS TOGEHTER
                replacedHtml_Body = replacedHtml_Body + replacedHtml_Row;
              }
            }
            $element.html(replacedHtml_Body); //WAS WORKING FINE

            //REMOVE THE ELEMENTS CHILDREN
            //$element.children().empty();
            //elementHTML = replacedHtml_Body;
          }
        }
      }
      //TESTING ELSE CLAUSE

    });

    return htmlObj.html();
  }


  docCreator_ReplaceHTML_With_Answer_Image_Table(htmlString: string, answerSchema: documentAnswerSchema[]) {
    const htmlObj = cheerio.load(htmlString);

    htmlObj('*').find('*').each((index, element) => {
      const $element = htmlObj(element);
      const element_Table = $element.attr('data-table');

      const element_Table_Loop = $element.attr('data-row-loop');
      if (element_Table_Loop) {
        //EMPTY ELEMENTS CHILDREN

        const tableMatchLoop = element_Table_Loop.match(/\{!(.*?)\}/);
        if (tableMatchLoop) {
          const tableMatchColumn = tableMatchLoop[1];

          const schema = answerSchema.find(item => item.column === tableMatchColumn);
          if (schema) {
            var replacedHtml_Body = "";

            if (schema.tableData) {

              for (var i in schema.tableData) {
                var replacedHtml_Row = $element.html().toString(); //WAS WORKING FINE
                const tableMatches = $element.text().match(/\{!(.*?)\}/g); //CHECK THE TEXT, NOT THE ELEMENT PROPERTIES
                if (tableMatches) {
                  tableMatches.forEach((match) => {
                    const tableRowColumn = match.substr(2, match.length - 3);
                    //JARED


                    for (var ti in schema.tableData[i].rowAnswers) {
                      console.log("Row Test");

                      const tableRowColumnIndex = schema.tableData[i].rowAnswers.findIndex(r => r.column === tableRowColumn);

                      if (tableRowColumnIndex > -1) {
                        var tableRowColumnAnswer = schema.tableData[i].rowAnswers[tableRowColumnIndex].answer;

                        switch (schema.tableData[i].rowAnswers[tableRowColumnIndex].questionType) {

                          case "Date":
                            console.log("Table Row is Date: " + tableRowColumnAnswer);
                            if (tableRowColumnAnswer && tableRowColumnAnswer !== "") {
                              tableRowColumnAnswer = this.formatDate_MM_DD_YYYY(new Date(tableRowColumnAnswer))
                            }

                            break;
                          case "Attachment":
                            break;
                          case "Data Upload":
                            break;
                          case "Table":
                            break;
                          case "Image":
                          case "Multiple Choice":
                          case "Multiple Selection":
                          case "Number":
                          case "Time":
                          case "Text Box":
                          case "Text Field":
                          case "True/False":
                          case "HTML Text Box":
                          default:

                            break;
                        }

                        replacedHtml_Row = replacedHtml_Row.replace(new RegExp(`\\{!${tableRowColumn}\\}`, "g"), tableRowColumnAnswer);

                      }
                    }
                  });
                }

                //MERGE THE HTML FOR ALL ROWS TOGEHTER
                replacedHtml_Body = replacedHtml_Body + replacedHtml_Row;
              }
            }
            $element.html(replacedHtml_Body); //WAS WORKING FINE

            //REMOVE THE ELEMENTS CHILDREN
            //$element.children().empty();
            //elementHTML = replacedHtml_Body;
          }
        }
      }
      //TESTING ELSE CLAUSE

    });

    return htmlObj.html();
  }


  docCreator_ReplaceHTML_With_Answer(htmlString: string, answerSchema: documentAnswerSchema[]) {
    const htmlObj = cheerio.load(htmlString);

    htmlObj('*').find('*').each((index, element) => {
      const $element = htmlObj(element);
      const element_Table = $element.attr('data-table');


      const matches = $element.text().match(/\{!(.*?)\}/g);
      if (matches) {
        matches.forEach((match) => {
          const column = match.substr(2, match.length - 3);
          const schema = answerSchema.find(item => item.column === column);
          //if ($element[0].children.length === 1 && $element[0].children[0].type === "text") {

          if (schema) {
            var answer = schema.answer || "";
            //switch (schema.)

            switch (schema.questionType) {

              case "Date":
                if (answer && answer !== "") {
                  answer = this.formatDate_MM_DD_YYYY(new Date(answer))
                }

                break;
              case "Attachment":
                break;
              case "Data Upload":
                break;
              case "Table":
                break;
              case "Image":
              case "Multiple Choice":
              case "Multiple Selection":
              case "Number":
              case "Time":
              case "Text Box":
              case "Text Field":
              case "True/False":
              case "HTML Text Box":
              default:

                break;
            }

            const replacedHtml = $element.html().replace(new RegExp(`\\{!${column}\\}`, "g"), answer);
            $element.html(replacedHtml);
          }

        });
      }


    });
    return htmlObj.html();
  }







  //DISMISS ALL SNACKBAR ALERTS
  private dismiss_Alerts_Data_Changed = new Subject<any>();
  get get_dismiss_Alerts() {
    return this.dismiss_Alerts_Data_Changed.asObservable();
  }
  update_dismiss_Alerts(data) {
    this.dismiss_Alerts_Data_Changed.next(data);
  }

  getValidAuthHours(online) {
    if (online) {
      return this.globals.getOnlineAuthHours;
    } else {
      return this.globals.getOfflineAuthHours;
    }
  }


  updateModuleHeatMap(moduleTypeRef, moduleValue) {


    this.getItem(moduleTypeRef, (results) => {
      //const moduleValue = moduleValue;
      var heatMapArray = [];
      var dataObj_homeModuleClickHeatmap = {
        itemName: "homeModuleClickHeatmap",
        value: {}
      };

      var heatMapObj = {
        moduleValue: moduleValue,
        moduleCount: 1
      }

      if (results.itemFound) {
        var moduleValueIndex = results.value.data.findIndex(v => v.moduleValue === moduleValue);
        if (moduleValueIndex > -1) {
          results.value.data[moduleValueIndex].moduleCount++;
        } else {
          results.value.data.push(heatMapObj)
        }
        dataObj_homeModuleClickHeatmap.value = { ...results.value }
        this.updateItem(dataObj_homeModuleClickHeatmap, (results) => { });

      } else {

        heatMapArray.push(heatMapObj);
        var heatMapDataObj = { data: heatMapArray }

        dataObj_homeModuleClickHeatmap.value = heatMapDataObj
        this.updateItem(dataObj_homeModuleClickHeatmap, (results) => { });
      }
    });



  }


  public showAlert(data: customAlertMessage) {

    var duration = 3000; if (data.duration) { duration = data.duration; }
    var horizontalPosition: MatSnackBarHorizontalPosition = "right"; if (data.horizontalPosition) { horizontalPosition = data.horizontalPosition; }
    var verticalPosition: MatSnackBarVerticalPosition = "top"; if (data.verticalPosition) { verticalPosition = data.verticalPosition; }
    var action = "Ok"; if (data.action) { action = data.action; }
    var snackType = ""; if (data.snackType) { snackType = data.snackType; }

    //const _snackType: snackType = snackType !== undefined ? snackType : 'Success';

    var panelClass = "";
    switch (data.severity) {
      case "success":
        panelClass = "success-snackbar";
        snackType = "Success";
        break;
      case "error":
        panelClass = "error-snackbar";
        snackType = "Error";
        break;
      case "default":
        panelClass = "default-snackbar";
        break;
      case "info":
        panelClass = "default-snackbar";
        snackType = "Info";
        break;
      default:
        panelClass = "lightgray-snackbar";
        break;
    }

    this.zone.run(() => {
      var config: MatSnackBarConfig = {
        duration: duration,
        horizontalPosition: horizontalPosition,
        verticalPosition: verticalPosition,
        data: { message: data.message, snackType: snackType },
        panelClass: [panelClass]
      }

      this._snackBar.openFromComponent(AlertMessageCustomComponent, config);

    });
  }


  public tourActions(action: string, timeOut = undefined) {

    switch (action) {
      case "preventMove":
        this.tourdriver.preventMove();
        break;

      case "moveNext":
        if (timeOut) {
          setTimeout(() => {
            this.tourdriver.moveNext();
          }, timeOut);
        } else {
          this.tourdriver.moveNext();
        }
        break;

    }
  }



  public takeATour(
    tourTitle,
    tourData,
    allowClose = false
  ) {
    this.zone.run(() => {

      this.tourdriver = new Driver({
        opacity: 0.5,
        animate: false,
        //allowClose: allowClose,
        doneBtnText: "Done",
        nextBtnText: "Next",
        closeBtnText: "Close",
        prevBtnText: "Back",
        keyboardControl: true,
      });


      var checkForTour = () => {
        var takeTheTour = () => {
          this.tourdriver.defineSteps(tourData);
          this.tourdriver.start();
        }


        this.getItem("viewedPowerFormsTour", (results) => {
          if (!results.value) {
            takeTheTour();
          }
        });

      }
      checkForTour();
    });
  }


  dateParse(date) {
    var a = date.toString().split(/[^0-9]/);
    var returnDate = new Date(a[0], a[1] - 1, a[2]);
    return returnDate;
  }



  ExcelDateToJSDate(serial) {
    var utc_days = Math.floor(serial - 25569);
    var utc_value = utc_days * 86400;
    var date_info = new Date(utc_value * 1000);

    var fractional_day = serial - Math.floor(serial) + 0.0000001;

    var total_seconds = Math.floor(86400 * fractional_day);

    var seconds = total_seconds % 60;

    total_seconds -= seconds;

    var hours = Math.floor(total_seconds / (60 * 60));
    var minutes = Math.floor(total_seconds / 60) % 60;

    // date_info is UTC midnight; local getters would shift it to the previous day west of UTC.
    return new Date(date_info.getUTCFullYear(), date_info.getUTCMonth(), date_info.getUTCDate(), hours, minutes, seconds);
  }

  //SETS FOCUS FOR HTML INPUTS
  targetSetFocus(event: any) {
    event.target.select()
  }

  dateParseString(date) {
    //var b: any = new Date(this.formatDate(date.toString()));
    var b: any = this.formatDate(date.toString());
    var a = b.toString().split(/[^0-9]/);
    var returnDate = new Date(a[0], a[1] - 1, a[2]);
    return returnDate;
  }

  formatDate_MM_DD_YYYY(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [month, day, year].join('/');
  }

  formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('-');
  }

  parseLocalDate(value) {
    let d;
    if (value instanceof Date) {
      d = value;
    } else if (typeof value === "string") {
      // Handle ISO date-only safely: YYYY-MM-DD
      if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        const [y, m, day] = value.split("-").map(Number);
        return new Date(y, m - 1, day);
      }

      // Fallback for strings like: "Thu Jun 05 2025 00:00:00"
      d = new Date(value);
      if (isNaN(d)) {
        //throw new Error(`Invalid date string: ${value}`);
        return value;
      }
    } else {
      //throw new Error("parseLocalDate expects a string or Date");
      return value;
    }
    // Normalize to local midnight
    return new Date(
      d.getFullYear(),
      d.getMonth(),
      d.getDate()
    );
  }

  toCalendarDate(value) {
    if (value === undefined || value === null || value === "") {
      return value;
    }

    if (typeof value === "string") {
      var valueTrimmed = value.trim();

      if (/^\d{4}-\d{1,2}-\d{1,2}$/.test(valueTrimmed)) {
        var ymd = valueTrimmed.split("-").map(Number);
        return new Date(ymd[0], ymd[1] - 1, ymd[2], 12, 0, 0, 0);
      }

      if (/^\d{1,2}[\/-]\d{1,2}[\/-]\d{4}$/.test(valueTrimmed)) {
        var mdy = valueTrimmed.split(/[\/-]/).map(Number);
        return new Date(mdy[2], mdy[0] - 1, mdy[1], 12, 0, 0, 0);
      }
    }

    var parsedDate: any = value;
    if (!(parsedDate instanceof Date)) {
      parsedDate = this.parseLocalDate(value);
    }

    var d = parsedDate instanceof Date ? parsedDate : new Date(parsedDate);
    if (isNaN(d.getTime())) {
      return value;
    }

    return new Date(
      d.getFullYear(),
      d.getMonth(),
      d.getDate(),
      12,
      0,
      0,
      0
    );
  }

  parseLocalDateTime(value) {
    let d;
    if (value instanceof Date) {
      d = value;
    } else if (typeof value === "string") {
      // Handle ISO date-only safely: YYYY-MM-DD
      if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        const [y, m, day] = value.split("-").map(Number);
        return new Date(y, m - 1, day);
      }

      // Fallback for strings like: "Thu Jun 05 2025 00:00:00"
      d = new Date(value);
      if (isNaN(d)) {
        //throw new Error(`Invalid date string: ${value}`);
        return value;
      }
    } else {
      //throw new Error("parseLocalDate expects a string or Date");
      return value;
    }
    // Normalize to local midnight
    return new Date(
      d.getFullYear(),
      d.getMonth(),
      d.getDate()
    );
  }


  /*
  parseEstToLocal(value) {
    if (!value) return value;

    // Parse as if the value is in America/New_York
    const estDate = new Date (
      new Intl.DateTimeFormat("en-US", {
        timeZone: "America/New_York",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false
      }).formatToParts(new Date(value))
        .reduce((acc, part) => {
          acc[part.type] = part.value;
          return acc;
        }, {})
      |> ((p: any) =>
        `${p.year}-${p.month}-${p.day}T${p.hour}:${p.minute}:${p.second}`
      )
    );

    // estDate is now a real Date object that will display in the user's local time
    return estDate;
  }
  */




  /*
  formatDateTimeMM_DD_YYYY_HH_MM_SS(date: Date): string {
    return `${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getDate().toString().padStart(2, '0')}/${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
  }
  */

  formatDateTimeYYYY_MM_DD_HH_MM_SS(date: Date): string {
    return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}T${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}.000`;
  }

  stdTimezoneOffset(date) {
    var jan = new Date(date.getFullYear(), 0, 1);
    var jul = new Date(date.getFullYear(), 6, 1);
    return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
  }

  isDstObserved(date) {
    var stdTimezoneOffset = stdTimezoneOffset(date);
    return date.getTimezoneOffset() < stdTimezoneOffset();
  }

  //CHECK IF DAYLIGHTSAVINGS
  isDST(d: Date) {
    let jan = new Date(d.getFullYear(), 0, 1).getTimezoneOffset();
    let jul = new Date(d.getFullYear(), 6, 1).getTimezoneOffset();
    return Math.max(jan, jul) !== d.getTimezoneOffset();
  }

  normalizeDate(date) {
    var d = new Date(date)
    var d1 = new Date(date);
    //I BELIEVE THIS CONVERT UTC TO EST TIME - 2-5-2024
    var isDaylightSavings = this.isDST(d1);
    if (isDaylightSavings) {
      var d = new Date(d1.getTime() - (d1.getTimezoneOffset() + 100) * -60000);
      return d;
    } else {
      var d = new Date(d1.getTime() - d1.getTimezoneOffset() * -60000);
      return d;
    }

    ////var d = new Date(d1.getTime() - d1.getTimezoneOffset() * -60000);
    //var d = new Date(d1.getTime() - (d1.getTimezoneOffset() + 100) * -60000);
    //return d;
  }


  //new date function, not used anywhere but to test - 2-5-2024
  normalizeDate_EST(date) {
    var d = new Date(date);
    var d1 = new Date(date);

    var isDaylightSavings = this.isDST(d1);
    var offset = isDaylightSavings ? -4 : -5; // Offset for EST (Eastern Standard Time) or EDT (Eastern Daylight Time)

    var normalizedDate = new Date(d1.getTime() - (d1.getTimezoneOffset() + offset) * 60000);
    return normalizedDate;
  }




  serializeQueryParams(params: any): string {
    const queryParams = [];
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        queryParams.push(`${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`);
      }
    }
    return queryParams.join('&');
  }

  parseUrl_For_Cache(fullUrl, label, title) {
    const url = new URL(fullUrl);
    const urlPath = url.pathname + url.search;
    const fullPath = url.href;
    const params = url.search.slice(1);
    const path = urlPath.split('?')[0];

    var locObject = {
      label: label,
      title: title,
      queryParams: {
        fullPath: fullPath,
        urlPath: urlPath,
        params: params,
        path: path
      }
    }
    return locObject
    //return { fullPath, urlPath, params, path };
  }


  updatePortal_CachedLocation(url = undefined, label = "", title = "") {

    if (url) {
      var urlObject = this.parseUrl_For_Cache(url, label, title);

      var cachedURLs = [];

      //GET RECENT URL LOCATION FROM CACHE AS PLACE HOLDER
      this.getItem("userCachedURLLocations", (results) => {
        if (results.itemFound) {
          if (results.value) {
            //CHECK IF VALUE EXISTS, IS AN ARRAY, AND THE ARRAY HAS ELEMENTS
            if (Array.isArray(results.value)) {
              if (results.value.length > 0) {
                //CHECK IF LOCATION ALREADY EXISTS, IF SO THEN REMOVE IT AND RE ADD AS FIRST ITEM
                //var existingURL_Index = results.value.findIndex(o => o.queryParams.fullPath === urlObject.queryParams.fullPath)

                var existingURL_Index = results.value.findIndex((o) => {
                  //console.log("Test");
                  return o.queryParams.fullPath === urlObject.queryParams.fullPath;
                })

                if (existingURL_Index > -1) {
                  results.value.splice(existingURL_Index, 1);
                }

                //IF MORE THAN 10 ITEMS, REMOVE THE LAST ONE
                if (results.value.length > 10) {
                  results.value.splice(-1)
                }

                var urlLocationsCache = [urlObject, ...results.value];
                this.updateItem({ itemName: "userCachedURLLocations", value: JSON.parse(JSON.stringify(urlLocationsCache)) }, (results) => { });

                this.update_user_recent_url_locations(urlLocationsCache);
              }
            }
          }
        } else {
          //NO CACHED URLS FOUND
          cachedURLs.push(urlObject);
          this.updateItem({ itemName: "userCachedURLLocations", value: cachedURLs }, (results) => { });
          this.update_user_recent_url_locations(urlLocationsCache);
        }
      })
    } else {
      //NO NEW URL WAS PROVIDED, GET EXISTING RECORDS
      this.getItem("userCachedURLLocations", (results) => {
        if (results.itemFound) {
          if (results.value) {
            //CHECK IF VALUE EXISTS, IS AN ARRAY, AND THE ARRAY HAS ELEMENTS
            if (Array.isArray(results.value)) {
              if (results.value.length > 0) {
                var urlLocationsCache = [...results.value];
                this.update_user_recent_url_locations(urlLocationsCache);
              }
            }
          }
        }
      })
    }

  }


  menuItemFilter(array, search, searchFields) {
    const arrayCopy = JSON.parse(JSON.stringify(array))

    return arrayCopy.filter(item => {
      let found = searchFields.some(field => {
        return item[field].toLowerCase().indexOf(search.toLowerCase()) > -1
      })

      var subItemsFound = false;
      if (item.items) {
        if (item.items.length > 0) {
          item.items = this.menuItemFilter(item.items, search, searchFields)
          if (item.items) {
            subItemsFound = true;
          }
        }
      }


      if (found || subItemsFound) {
        console.log("test");
      }

      return found || subItemsFound //item.items.length > 0
    })
  }


  filterByProperty(array, prop, value) {
    var filtered = [];
    for (var i = 0; i < array.length; i++) {
      var obj = array[i];
      for (var key in obj) {
        if (typeof (obj[key] == "object")) {
          var item = obj[key];
          if (item[prop] == value) {
            filtered.push(item);
          }
        }
      }
    }
    return filtered;
  }

  dedupeByKeyFilter(arr, key) {
    const temp = arr.map(el => el[key]);
    return arr.filter((el, i) =>
      temp.indexOf(el[key]) === i
    );
  }


  bytesToMB(sizeInBytes) {
    return (sizeInBytes / (1024 * 1024)).toFixed(2) + "MB";
  }

  kiloBytesToMB(sizeInBytes) {
    //return (sizeInBytes / (1024 * 10)).toFixed(2) + "MB";
    return (sizeInBytes / (1024 * 10.24)).toFixed(2) + "MB";
  }

  setTitle(title) {
    this.titleService.setTitle(title);
  }


  btoa_encode_json(jsonArray) {
    var returnString = JSON.stringify(jsonArray);
    returnString = this.escape_string_SQL_Remove_Apostrophe(returnString);
    try {
      returnString = btoa(returnString);
    } catch (error) {
      returnString = btoa(unescape(encodeURIComponent(returnString)));
    }
    return returnString;
  }

  /**
  * Validates and converts the current date/time based on the user's timezone.
  *
  * If the timezone is in `Asia`, it converts the date to `America/New_York` timezone.
  *
  * Otherwise, it returns the current date in the user's timezone.
  *
  * @returns {moment.Moment} Converted date in `America/New_York` timezone or the current date.
  */
  momentsTimeZoneValidator(endDate, timeZone) {

    var inputDate = moment(endDate);

    // Splits user's timezone by continent and city
    var [continent, city] = timeZone.split('/');

    // Switch to handle multiple timezones
    switch (continent) {
      // Case when the continent is Asia
      case 'Asia':
        // Get current time in the Asian continent
        //var asiaDate = moment().tz(`${continent}/${city}`);
        var asiaDate = inputDate.clone().tz(`${continent}/${city}`);

        // Translates the Asian date/time to "Our" timezone date/time utc
        var transformedDate = asiaDate.clone().tz('America/New_York');

        var formattedDate = moment(transformedDate).format('YYYY-MM-DD');

        // Returns the translated date
        return formattedDate;
        break;
      default:
        // Returns "Our" date/time utc
        //return moment().utc();
        return inputDate.tz('America/New_York').format('YYYY-MM-DD');
        break;
    }
  }

  //NOT USED, USE 'newDate_EST' INSTEAD
  convertTimeZoneToEST(endDate, timeZone) {
    var inputDate = moment(endDate).tz(timeZone);

    // Convert the input date to "America/New_York" timezone
    var newYorkDate = inputDate.clone().tz('America/New_York');

    // Format the date in 'YYYY-MM-DD' format
    //var formattedDate = newYorkDate.format('YYYY-MM-DD');

    // Return the formatted date
    //return formattedDate;
    //return newYorkDate.startOf('day').toDate();
    return new Date(newYorkDate.format())
  }


  EstToLocal(date) {
  return moment
    .tz(date, 'America/New_York') // tell moment what zone the input is in
    .local()                      // convert to user's local zone
    .toDate();                    // safe Date object
  }

  utcToLocal(date) {
    return moment.utc(date).local().toDate();
  }

  newDate_EST(date) {
    var timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    var inputDate = moment(date).tz(timeZone);

    if (!inputDate.isValid()) {
        try {
            inputDate = moment(date, "MMM DD YYYY h:mmA").tz(timeZone);
        } catch (e) {
            console.error("Failed to parse date:", date);
            return null;
        }
    }

    // Convert the input date to "America/New_York" timezone
    var newYorkDate = inputDate.clone().tz('America/New_York');
    // Return the formatted date
    //return newYorkDate.startOf('day').toDate();
    return new Date(newYorkDate.format())
  }

  newDate_EST_String(date) {
    var timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    var inputDate = moment(date).tz(timeZone);

     if (!inputDate.isValid()) {
        try {
            inputDate = moment(date, "MMM DD YYYY h:mmA").tz(timeZone);
        } catch (e) {
            console.error("Failed to parse date:", date);
            return null;
        }
    }

    // Convert the input date to "America/New_York" timezone
    //var newYorkDate = inputDate.clone().tz('America/New_York');

    // Format the date in 'YYYY-MM-DD' format
    var formattedDate = inputDate.format('YYYY-MM-DD');

    // Return the formatted date
    return formattedDate;
  }


  formatDates_JSONstringify(jsonObj) {
  // Check if the given object is an array
  if (Array.isArray(jsonObj)) {
    // If it's an array, loop through each element and apply the function recursively
    for (let i = 0; i < jsonObj.length; i++) {
      jsonObj[i] = this.formatDates_JSONstringify(jsonObj[i]);
    }
  } else if (typeof jsonObj === 'object' && jsonObj !== null) {
    // If it's an object, loop through each key-value pair and apply the function recursively
    for (const key in jsonObj) {
      if (jsonObj instanceof Date) {
        //const formattedDate = jsonObj.toISOString().replace(/T/, ' ').replace(/\..+/, '');
        const formattedDate = this.newDate_EST_String(jsonObj);
        return formattedDate;
      } else {
        if (jsonObj.hasOwnProperty(key)) {
          jsonObj[key] = this.formatDates_JSONstringify(jsonObj[key]);
        }
      }
    }
  }
  return jsonObj;
}





parseMultipartData(text: string, boundary: string): MultipartPart[] {
  // 1. Normalize line endings and prepare boundary patterns
  const normalizedText = text.replace(/\r\n/g, '\n');
  const boundaryStart = `--${boundary}\n`;
  const boundaryEnd = `--${boundary}--\n`;

  // 2. Remove the final boundary if present
  let cleanText = normalizedText.endsWith(boundaryEnd)
    ? normalizedText.slice(0, -boundaryEnd.length)
    : normalizedText;

  // 3. Split into parts using the boundary
  const parts = cleanText.split(boundaryStart)
    .filter(part => part.trim().length > 0);

  // 4. Process each part
  return parts.map(part => {
    const headerEnd = part.indexOf('\n\n');
    if (headerEnd === -1) {
      return {
        headers: {},
        content: part
      };
    }

    const headerText = part.substring(0, headerEnd);
    const content = part.substring(headerEnd + 2); // Skip the two newlines

    return {
      headers: this.parseHeaders(headerText),
      content: content
    };
  });
}

parseHeaders(headerText: string): Record<string, string> {
  const headers: Record<string, string> = {};

  headerText.split('\n').forEach(line => {
    const colonIndex = line.indexOf(':');
    if (colonIndex > 0) {
      const key = line.substring(0, colonIndex).trim();
      const value = line.substring(colonIndex + 1).trim();
      headers[key] = value;

      // Parse Content-Disposition filename if present
      if (key.toLowerCase() === 'content-disposition') {
        const filenameMatch = value.match(/filename="([^"]+)"/i) || value.match(/filename=([^;]+)/i);
        if (filenameMatch) {
          headers.filename = filenameMatch[1].trim();
        }
      }
    }
  });

  return headers;
}


  private app_modules_data = new Subject<any>();
  get get_app_modules_data() {
    return this.app_modules_data.asObservable();
  }
  update_app_modules_data(data) {
    this.app_modules_data.next(data);
  }

  //MODULE LIST CHANGE
  private module_list_changed = new Subject<any>();
  get get_module_list() {
    return this.module_list_changed.asObservable();
  }
  update_module_list(data) {
    this.module_list_changed.next(data);
  }


  checkModuleActiveNew(module, submodule = "") {
    return new Promise((resolve) => {
      //this.getItem("moduleList", (results) => {
        if (!this.globals.activeModules || !Array.isArray(this.globals.activeModules) || this.globals.activeModules.length === 0) {
          return resolve(true);
        }
      const moduleEntry = this.globals.activeModules.find(
          (m) => m.name?.toLowerCase() === module.toLowerCase()
        );

        if (!moduleEntry) return resolve(true);

        // If no submodule is provided, return module active status
        if (!submodule) {
          return resolve(!!moduleEntry.isActive);
        }

        // Otherwise, check submodule
        const submoduleEntry = moduleEntry.moduleData?.find(
          (s) => s.module?.toLowerCase() === submodule.toLowerCase()
        );

        return resolve(submoduleEntry ? !!submoduleEntry.isActive : false);
      //});
    });
  }


  setModulesList_Remove(userObject: User, moduleList, application = "") {

    return new Promise((resolve) => {

      if (!this.globals.activeModules || !Array.isArray(this.globals.activeModules) || this.globals.activeModules.length === 0) {
        return resolve(moduleList);
      }

      let updatedModuleList = structuredClone(moduleList);

      // If "application" is provided, check only that application's moduleData
      if (application) {
        //console.log(`Filtering modules for application: ${application}`);

        // Find the matching application in results.value
        const appEntry = this.globals.activeModules.find(r => r.name === application);

        if (!appEntry) {
          //console.warn(`Application "${application}" not found in results.value`);
          return resolve(updatedModuleList);
        }

        // If appEntry has moduleData, filter by isActive flag
        if (Array.isArray(appEntry.moduleData) && appEntry.moduleData.length > 0) {
          updatedModuleList = updatedModuleList.filter(moduleItem => {
            const match = appEntry.moduleData.find(md => md.module === moduleItem.value);
            // Keep if not found (not controlled by this app) or if active
            return !match || match.isActive !== false;
          });
        }

        //console.log("Filtered (Application-specific) ModuleList: " + JSON.stringify(updatedModuleList));
        return resolve(updatedModuleList);
      }

      // Default behavior (no application passed) – global check
      updatedModuleList = updatedModuleList.filter(moduleItem => {
        const moduleName = moduleItem.value;
        // Direct match in results.value
        const directMatch = this.globals.activeModules.find(r => r.name === moduleName);
        if (userObject.isGlobalAdmin && directMatch && directMatch.isActiveAdmin === true && directMatch.isActive === false) {
          moduleItem.adminOnly = true;
        }
        if (userObject.isGlobalAdmin && directMatch && directMatch.isActiveAdmin === true) return true;
        if (directMatch && directMatch.isActive === false) return false;
        // Nested moduleData check
        const nestedMatch = this.globals.activeModules.map(r => Array.isArray(r.moduleData) ? r.moduleData : [])
          .find(md => md.module === moduleName);

        if (userObject.isGlobalAdmin && (nestedMatch && nestedMatch.isActiveAdmin === true)) return true;
        if (nestedMatch && nestedMatch.isActive === false) return false;

        /*
        if ((nestedMatch && nestedMatch.isActive === false && (!userObject.isGlobalAdmin || userObject.isGlobalAdmin === undefined))
          || (nestedMatch && nestedMatch.isActive === false && (!userObject.isGlobalAdmin || userObject.isGlobalAdmin === undefined))
        ) return false;
        */

        return true;
      });

      //console.log("Filtered (Global) ModuleList: " + JSON.stringify(updatedModuleList));
      return resolve(updatedModuleList);
    });

  }


  /*
  setModulesList(moduleList, application = "") {
    //console.log("moduleList: " + JSON.stringify(moduleList));

    return new Promise((resolve) => {
      //this.getItem("moduleList", (results) => {
        if (!this.globals.activeModules || !Array.isArray(this.globals.activeModules) || this.globals.activeModules.length === 0) {
          return resolve(moduleList);
        }

        //console.log("Active ModuleList: " + JSON.stringify(results.value));

        let updatedModuleList = structuredClone(moduleList);

        // If "application" is provided, check only that application's moduleData
        if (application) {
          //console.log(`Filtering modules for application: ${application}`);

          // Find the matching application in results.value
          const appEntry = results.value.find(r => r.name === application);

          if (!appEntry) {
            //console.warn(`Application "${application}" not found in results.value`);
            return resolve(updatedModuleList);
          }

          // If appEntry has moduleData, filter by isActive flag
          if (Array.isArray(appEntry.moduleData) && appEntry.moduleData.length > 0) {
            updatedModuleList = updatedModuleList.filter(moduleItem => {
              const match = appEntry.moduleData.find(md => md.module === moduleItem.value);
              // Keep if not found (not controlled by this app) or if active
              return !match || match.isActive !== false;
            });
          }

          //console.log("Filtered (Application-specific) ModuleList: " + JSON.stringify(updatedModuleList));
          return resolve(updatedModuleList);
        }

        // Default behavior (no application passed) – global check
        updatedModuleList = updatedModuleList.filter(moduleItem => {
          const moduleName = moduleItem.value;

          // Direct match in results.value
          const directMatch = this.globals.activeModules.find(r => r.name === moduleName);
          if (directMatch && directMatch.isActive === false) return false;

          // Nested moduleData check
          const nestedMatch = this.globals.activeModules.map(r => Array.isArray(r.moduleData) ? r.moduleData : [])
            .find(md => md.module === moduleName);

          if (nestedMatch && nestedMatch.isActive === false) return false;

          return true;
        });

        //console.log("Filtered (Global) ModuleList: " + JSON.stringify(updatedModuleList));
        return resolve(updatedModuleList);
      //});
    });
  }
  */


  setModulesList(userObject: User, moduleList: any[], application: string = "", key: string = "value", showKey: string = "showModule"): Observable<any[]> {
    try {
      if (!this.globals.activeModules || !Array.isArray(this.globals.activeModules) || this.globals.activeModules.length === 0) {
        return of(moduleList);
      }

      let updatedModuleList = moduleList;

      // If "application" is provided, check only that application's moduleData
      if (application && application !== "") {
        const appEntry = this.globals.activeModules.find(r => r.name.toLowerCase() === application.toLowerCase());
        if (!appEntry) {
          return of(moduleList);
        }

        if (Array.isArray(appEntry.moduleData) && appEntry.moduleData.length > 0) {
          updatedModuleList = updatedModuleList.filter(moduleItem => {
            const match = appEntry.moduleData.find(md => md.module === moduleItem[key]);
            // Keep all modules as per original logic
            return true;
          });
        }
        return of(updatedModuleList);
      }

      // Default behavior (no application passed) – global check
      updatedModuleList.forEach(moduleItem => {
        const moduleName = moduleItem[key];

        const directMatch = this.globals.activeModules.find(r => r.name.toLowerCase() === moduleName.toLowerCase());
        if (userObject.isGlobalAdmin && directMatch && directMatch.isActiveAdmin === true && directMatch.isActive === false) {
          moduleItem.adminOnly = true;
        }
        if (userObject.isGlobalAdmin && directMatch && directMatch.isActiveAdmin === true) {
          moduleItem[showKey] = true;
        } else {
          if (directMatch && directMatch.isActive === false) {
            moduleItem[showKey] = false;
          }
        }

        const nestedMatch = this.globals.activeModules
          .map(r => Array.isArray(r.moduleData) ? r.moduleData : [])
          .reduce((acc, val) => acc.concat(val), [] as any[])
          .find(md => md.module.toLowerCase() === moduleName.toLowerCase());

        if (userObject.isGlobalAdmin && (nestedMatch && nestedMatch.isActiveAdmin === true)) {
          moduleItem[showKey] = true;
        } else {
          if (nestedMatch && nestedMatch.isActive === false) {
            moduleItem[showKey] = false;
          }
        }
      });

      return of(updatedModuleList);
    } catch (err) {
      console.error("setModulesList error:", err);
      return throwError(() => err);
    }
  }

  setModulesList_SideNav(userObject: User, moduleList: any[], application: string = "", key: string = "value", showKey: string = "showModule"): Observable<any[]> {
    try {
      if (!this.globals.activeModules || !Array.isArray(this.globals.activeModules) || this.globals.activeModules.length === 0) {
        return of(moduleList);
      }

      let updatedModuleList = moduleList;

      // If "application" is provided, check only that application's moduleData
      if (application && application !== "") {
        const appEntry = this.globals.activeModules.find(r => r.name.toLowerCase() === application.toLowerCase());
        if (!appEntry) {
          return of(moduleList);
        }

        if (Array.isArray(appEntry.moduleData) && appEntry.moduleData.length > 0) {
          updatedModuleList = updatedModuleList.filter(moduleItem => {
            const match = appEntry.moduleData.find(md => md.module === moduleItem[key]);
            // Keep all modules as per original logic
            return true;
          });
        }
        return of(updatedModuleList);
      }

      // Default behavior (no application passed) – global check
      updatedModuleList.forEach(moduleItem => {
        const moduleName = moduleItem[key];

        const directMatch = this.globals.activeModules.find(r => r.name.toLowerCase() === moduleName.toLowerCase());
        if (userObject.isGlobalAdmin && directMatch && directMatch.isActiveAdmin === true && directMatch.isActive === false) {
          moduleItem.adminOnly = true;
        }
        if (userObject.isGlobalAdmin && directMatch && directMatch.isActiveAdmin === true) {
          moduleItem[showKey] = true;
        } else {
          if (directMatch && directMatch.isActive === false) {
            moduleItem[showKey] = false;
          }
        }

        const nestedMatch = this.globals.activeModules
          .map(r => Array.isArray(r.moduleData) ? r.moduleData : [])
          .reduce((acc, val) => acc.concat(val), [] as any[])
          .find(md => md.module.toLowerCase() === moduleName.toLowerCase());

        if (userObject.isGlobalAdmin && (nestedMatch && nestedMatch.isActiveAdmin === true)) {
          moduleItem[showKey] = true;
        } else {
          if (nestedMatch && nestedMatch.isActive === false) {
            moduleItem[showKey] = false;
          }
        }
      });

      return of(updatedModuleList);
    } catch (err) {
      console.error("setModulesList error:", err);
      return throwError(() => err);
    }
  }

  setModulesListPromise(userObject: User, moduleList, application = "") {
    return new Promise((resolve, reject) => {

      //this.zone.run(() => {
      try {

        if (!this.globals.activeModules || !Array.isArray(this.globals.activeModules) || this.globals.activeModules.length === 0) {
          return resolve(moduleList);
        }
        //let updatedModuleList = structuredClone(moduleList);
        let updatedModuleList = moduleList;
        // If "application" is provided, check only that application's moduleData
        if (application && application !== "") {
          // Find the matching application in results.value
          const appEntry = this.globals.activeModules.find(r => r.name === application);
          if (!appEntry) {
            return resolve(moduleList);
          }

          // If appEntry has moduleData, filter by isActive flag
          if (Array.isArray(appEntry.moduleData) && appEntry.moduleData.length > 0) {
            updatedModuleList = updatedModuleList.filter(moduleItem => {
              const match = appEntry.moduleData.find(md => md.module === moduleItem.value);
              // Keep if not found (not controlled by this app) or if active
              //return !match || match.isActive !== false;
              return true;
            });
          }
          return resolve(updatedModuleList);
        }
        // Default behavior (no application passed) – global check
        updatedModuleList.forEach(moduleItem => {
          const moduleName = moduleItem.value;
          // Direct match in results.value
          const directMatch = this.globals.activeModules.find(r => r.name === moduleName);
          if (userObject.isGlobalAdmin && directMatch && directMatch.isActiveAdmin === true && directMatch.isActive === false) {
            moduleItem.adminOnly = true;
          }
          if (userObject.isGlobalAdmin && directMatch && directMatch.isActiveAdmin === true) {
            moduleItem.showModule = true;
          } else {
            if (directMatch && directMatch.isActive === false) {
              moduleItem.showModule = false;
            }
          }
          // Nested moduleData check
          const nestedMatch = this.globals.activeModules.map(r => Array.isArray(r.moduleData) ? r.moduleData : [])
            .find(md => md.module === moduleName);

          if (userObject.isGlobalAdmin && (nestedMatch && nestedMatch.isActiveAdmin === true)) {
            moduleItem.showModule = true;
          } else {
            if (nestedMatch && nestedMatch.isActive === false) {
              moduleItem.showModule = false;
            }
          }
          return moduleItem;
        });
        return resolve(updatedModuleList);
      } catch (err) {
        console.error("setModulesList error:", err);
        reject(err);
      }
   //   });
    });
  }


  setModulesListMenu(moduleList: any[], application = "", applicationExeclusive: boolean = false) {
    return new Promise((resolve) => {
      if (!this.globals.activeModules || !Array.isArray(this.globals.activeModules) || this.globals.activeModules.length === 0) {
        return resolve(moduleList);
      }
      var updatedModuleList = [...moduleList];
      var subModuleList = [];
      if (application) {
        const appEntry = this.globals.activeModules.find(r => r.name === application);

        if (!appEntry) {
          return resolve(updatedModuleList);
        }

        // If appEntry has moduleData, filter by isActive flag
        if (Array.isArray(appEntry.moduleData) && appEntry.moduleData.length > 0) {
          updatedModuleList = updatedModuleList.filter(moduleItem => {
            const match = appEntry.moduleData.find(md => md.queryParams.applicationName === moduleItem.value);
            return !match || match.isActive !== false;
          });
        }
        if (applicationExeclusive) {
          return resolve(updatedModuleList);
        }
      }

      updatedModuleList = updatedModuleList.map(moduleItem => {
        const moduleName = moduleItem.queryParams.applicationName;
        const directMatch = this.globals.activeModules.find(r => r.name === moduleName);
        const nestedMatch = this.globals.activeModules
          .map(r => Array.isArray(r.moduleData) ? r.moduleData : [])
          .find(md => md.module === moduleName);

        // If either match is inactive (and is NOT the homge page), set visible to false
        if ((directMatch && directMatch.isActive === false && (!directMatch.isHomePage || directMatch.isHomePage === undefined)) ||
          (nestedMatch && nestedMatch.isActive === false && (!nestedMatch.isHomePage || nestedMatch.isHomePage === undefined))) {
          moduleItem.visible = false;
        }
        return moduleItem;
      });
      return resolve(updatedModuleList);
    });

  }


  getModuleList(userObject: User) {
    var data_List = [];


    var summaryData = [];
    var resultMessage = "";
    var isError = false;
    var employeeName = ""; if (userObject.name) { employeeName = userObject.name; }
    var employeeNumber = "0"; if (userObject.employeeNumber) { employeeNumber = userObject.employeeNumber; }
    var employeeEmail = ""; if (userObject.email) { employeeEmail = userObject.email; }

    var postData = [{
      dataRequest: "manager_system_variables",
      employeeName: employeeName,
      employeeEmail: employeeEmail,
      employeeNumber: employeeNumber,
      requestType: "get_module_list",
      ID: "",
      moduleData: "W10="
    }];

    this.powerPortalPostRequest(postData).pipe(takeUntil(this.ngUnsubscribe)).subscribe((response) => {

      if (response[0].result) {
        if (response[0].result.toLowerCase() === "error") {
          //this.webWorker_PowerPortal.logError(this.online, "Admin", response[0].resultMessage);
          resultMessage = response[0].resultMessage;
          isError = true;
        }
      } else {
        for (var i in response) {

          var name = ""; if (response[i].name) { name = response[i].name; }
          var description = ""; if (response[i].description) { description = response[i].description; }
          var canDelete = false;
          var canEdit = false; if (response[i].canEdit) { canEdit = response[i].canEdit; }
          var permissionRequired = false; if (response[i].permissionRequired) { permissionRequired = response[i].permissionRequired; }
          var id = 0; if (response[i].id) { id = response[i].id; }
          var moduleData = []; if (response[i].moduleData) { moduleData = JSON.parse(response[i].moduleData); }

          for (var m in moduleData) {
            if (moduleData[m].isActive === undefined) {
              moduleData[m].isActive = true;
            }
          }
          for (var m in moduleData) {
            if (moduleData[m].isActiveAdmin === undefined) {
              moduleData[m].isActiveAdmin = true;
            }
          }
          var moduleDataString = ""; // this.createModuleDataString(moduleData);
          var isActive = false; if (response[i].isActive) { isActive = response[i].isActive; }
          var status = "A"; if (response[i].status) { status = response[i].status; }
          var isActiveAdmin = false; if (response[i].isActiveAdmin) { isActiveAdmin = response[i].isActiveAdmin; }
          var statusAdmin = "A"; if (response[i].statusAdmin) { statusAdmin = response[i].statusAdmin; }
          var data_item: appModuleObject = {
            id: id,
            name: name,
            description: description,
            permissionRequired: permissionRequired,
            canEdit: canEdit,
            canDelete: canDelete,
            moduleData: moduleData,
            status: status,
            isActive: isActive,
            isActiveAdmin: isActiveAdmin,
            moduleDataString: moduleDataString,
          }

          data_List.push(data_item);
        }
      }
    }, (error) => {
      //SET DEFAULT ACTIVE LIST FROM CACHE
      this.getItem("moduleList", (results) => {
        if (!results.value) {
          if (Array.isArray(results.value)) {
            this.globals.activeModules = structuredClone(results.value);
          }
        }
      })

    }, () => {
      this.globals.activeModules = structuredClone(data_List);
      this.updateItem({ itemName: "moduleList", value: data_List }, (results) => { });
      this.update_app_modules_data(data_List);
    })
  }


  launchCelebration(duration: number = 1500): void {
    const end = Date.now() + duration;
    //const colors = ['#bb0000', '#ffffff'];
    const colors = [this.globals.brandColor_Qualus_Alt1, '#000000', this.globals.brandColor_Qualus_Alt2];
    //var colors = ['#004b2c', '#2bbebd', '#000000', '#36eee4'];

    function randomInRange(min, max) {
      return Math.random() * (max - min) + min;
    }

    this.zone.run(() => {
      confetti({
        //angle: randomInRange(55, 125),
        //spread: randomInRange(50, 70),
        particleCount: randomInRange(50, 100),
        scalar: 1.5,
        spread: 180,
        //particleCount: 30,
        origin: { y: -0.1 },
        startVelocity: -35,
        colors: colors
      });
      confetti({
        particleCount: randomInRange(10, 30),
        angle: 120,
        spread: 55,
        origin: { x: 1 },
        colors: colors
      });
      confetti({
        particleCount: randomInRange(10, 30),
        angle: 60,
        spread: 70,
        origin: { x: 0 },
        colors: colors
      });
    });
    /*
    (function frame() {
      confetti({
        particleCount: 3,
        angle: 60,
        spread: 55,
        origin: { x: 0 },
        colors: colors
      });
      confetti({
        particleCount: 3,
        angle: 120,
        spread: 55,
        origin: { x: 1 },
        colors: colors
      });

      if (Date.now() < end) {
        requestAnimationFrame(frame);
      }
    }());
    */



  }



}


export interface MultipartPart {
  headers: Record<string, string>;
  content: string;
}
